export const AssignableToTeam = {
  CARSETUP: 'CARSETUP',
  CONTESTANT: 'CONTESTANT',
  PERSON: 'PERSON',
  RUNSHEET: 'RUNSHEET'
} as const;

export type AssignableToTeam = typeof AssignableToTeam[keyof typeof AssignableToTeam];
/** Field to target with this mutation. */
export const ContestantField = {
  /** → `chassisIDs` */
  CHASSIS: 'CHASSIS',
  /** → `driverIDs` */
  DRIVERS: 'DRIVERS'
} as const;

export type ContestantField = typeof ContestantField[keyof typeof ContestantField];
export const EnumAccelerationUnit = {
  FEET_PER_SECOND_SQUARED: 'FEET_PER_SECOND_SQUARED',
  GFORCE: 'GFORCE',
  METRES_PER_SECOND_SQUARED: 'METRES_PER_SECOND_SQUARED'
} as const;

export type EnumAccelerationUnit = typeof EnumAccelerationUnit[keyof typeof EnumAccelerationUnit];
export const EnumAdjustablePropertyType = {
  ACCELERATION: 'ACCELERATION',
  ANGLE: 'ANGLE',
  ANGULAR_COMPLIANCE: 'ANGULAR_COMPLIANCE',
  ANGULAR_TORQUE_COMPLIANCE: 'ANGULAR_TORQUE_COMPLIANCE',
  BOOLEAN: 'BOOLEAN',
  COMPLIANCE: 'COMPLIANCE',
  FORCE: 'FORCE',
  INERTIA: 'INERTIA',
  LENGTH: 'LENGTH',
  LOCATION: 'LOCATION',
  MASS: 'MASS',
  NUMBER: 'NUMBER',
  ORIENTATION: 'ORIENTATION',
  POWER: 'POWER',
  PRESSURE: 'PRESSURE',
  RATIO: 'RATIO',
  SPRING_RATE: 'SPRING_RATE',
  STEERING_RACK_RATIO: 'STEERING_RACK_RATIO',
  STRING: 'STRING',
  TEMPERATURE: 'TEMPERATURE',
  TORQUE: 'TORQUE',
  TORSION_RATE: 'TORSION_RATE',
  VOLUME: 'VOLUME'
} as const;

export type EnumAdjustablePropertyType = typeof EnumAdjustablePropertyType[keyof typeof EnumAdjustablePropertyType];
export const EnumAeroElementInterpolationMethod = {
  AFLAP: 'AFLAP',
  CLOSEST: 'CLOSEST',
  LINEAR: 'LINEAR',
  NONE: 'NONE',
  POLYNOMIAL: 'POLYNOMIAL',
  SPLINE: 'SPLINE'
} as const;

export type EnumAeroElementInterpolationMethod = typeof EnumAeroElementInterpolationMethod[keyof typeof EnumAeroElementInterpolationMethod];
export const EnumAeroElementType = {
  INTERPOLATE: 'INTERPOLATE',
  POLYNOMIAL: 'POLYNOMIAL',
  STRICT: 'STRICT'
} as const;

export type EnumAeroElementType = typeof EnumAeroElementType[keyof typeof EnumAeroElementType];
export const EnumAngleUnit = {
  DEGREES: 'DEGREES',
  MINUTES: 'MINUTES',
  RADIANS: 'RADIANS'
} as const;

export type EnumAngleUnit = typeof EnumAngleUnit[keyof typeof EnumAngleUnit];
export const EnumAngularAccelerationUnit = {
  DEGREES_PER_SECOND_SQUARED: 'DEGREES_PER_SECOND_SQUARED',
  RADIANS_PER_SECOND_SQUARED: 'RADIANS_PER_SECOND_SQUARED'
} as const;

export type EnumAngularAccelerationUnit = typeof EnumAngularAccelerationUnit[keyof typeof EnumAngularAccelerationUnit];
export const EnumAngularComplianceUnit = {
  DEGREES_PER_POUND: 'DEGREES_PER_POUND',
  RADIANS_PER_NEWTON: 'RADIANS_PER_NEWTON'
} as const;

export type EnumAngularComplianceUnit = typeof EnumAngularComplianceUnit[keyof typeof EnumAngularComplianceUnit];
export const EnumAngularTorqueComplianceUnit = {
  DEGREES_PER_FOOT_POUND: 'DEGREES_PER_FOOT_POUND',
  RADIANS_PER_NEWTON_METRE: 'RADIANS_PER_NEWTON_METRE'
} as const;

export type EnumAngularTorqueComplianceUnit = typeof EnumAngularTorqueComplianceUnit[keyof typeof EnumAngularTorqueComplianceUnit];
export const EnumAngularVelocityUnit = {
  DEGREES_PER_SECOND: 'DEGREES_PER_SECOND',
  RADIANS_PER_SECOND: 'RADIANS_PER_SECOND'
} as const;

export type EnumAngularVelocityUnit = typeof EnumAngularVelocityUnit[keyof typeof EnumAngularVelocityUnit];
export const EnumAntiRollBarDisplayLocation = {
  FRONT: 'FRONT',
  REAR: 'REAR'
} as const;

export type EnumAntiRollBarDisplayLocation = typeof EnumAntiRollBarDisplayLocation[keyof typeof EnumAntiRollBarDisplayLocation];
/** Specify where the part type should be added in */
export const EnumAssemblyTemplateRequiredPartsLocation = {
  CENTER: 'CENTER',
  ENGINE_IN: 'ENGINE_IN',
  ENGINE_OUT: 'ENGINE_OUT',
  FRONT: 'FRONT',
  FRONT_LEFT: 'FRONT_LEFT',
  FRONT_LEFT_FORWARD: 'FRONT_LEFT_FORWARD',
  FRONT_LEFT_INNER: 'FRONT_LEFT_INNER',
  FRONT_LEFT_LCA_FWD: 'FRONT_LEFT_LCA_FWD',
  FRONT_LEFT_LCA_RWD: 'FRONT_LEFT_LCA_RWD',
  FRONT_LEFT_LOWER: 'FRONT_LEFT_LOWER',
  FRONT_LEFT_OUTER: 'FRONT_LEFT_OUTER',
  FRONT_LEFT_PUSHROD: 'FRONT_LEFT_PUSHROD',
  FRONT_LEFT_REARWARD: 'FRONT_LEFT_REARWARD',
  FRONT_LEFT_TIEROD: 'FRONT_LEFT_TIEROD',
  FRONT_LEFT_UCA_FWD: 'FRONT_LEFT_UCA_FWD',
  FRONT_LEFT_UCA_RWD: 'FRONT_LEFT_UCA_RWD',
  FRONT_LEFT_UPPER: 'FRONT_LEFT_UPPER',
  FRONT_PRIMARY: 'FRONT_PRIMARY',
  FRONT_RIGHT: 'FRONT_RIGHT',
  FRONT_RIGHT_FORWARD: 'FRONT_RIGHT_FORWARD',
  FRONT_RIGHT_INNER: 'FRONT_RIGHT_INNER',
  FRONT_RIGHT_LCA_FWD: 'FRONT_RIGHT_LCA_FWD',
  FRONT_RIGHT_LCA_RWD: 'FRONT_RIGHT_LCA_RWD',
  FRONT_RIGHT_LOWER: 'FRONT_RIGHT_LOWER',
  FRONT_RIGHT_OUTER: 'FRONT_RIGHT_OUTER',
  FRONT_RIGHT_PUSHROD: 'FRONT_RIGHT_PUSHROD',
  FRONT_RIGHT_REARWARD: 'FRONT_RIGHT_REARWARD',
  FRONT_RIGHT_TIEROD: 'FRONT_RIGHT_TIEROD',
  FRONT_RIGHT_UCA_FWD: 'FRONT_RIGHT_UCA_FWD',
  FRONT_RIGHT_UCA_RWD: 'FRONT_RIGHT_UCA_RWD',
  FRONT_RIGHT_UPPER: 'FRONT_RIGHT_UPPER',
  FRONT_SECONDARY: 'FRONT_SECONDARY',
  GBX_IN: 'GBX_IN',
  GBX_OUT: 'GBX_OUT',
  INPUT: 'INPUT',
  LEFT: 'LEFT',
  MGU_IN: 'MGU_IN',
  MGU_OUT: 'MGU_OUT',
  OUTPUT: 'OUTPUT',
  PRIMARY: 'PRIMARY',
  REAR: 'REAR',
  REAR_LEFT: 'REAR_LEFT',
  REAR_LEFT_FORWARD: 'REAR_LEFT_FORWARD',
  REAR_LEFT_INNER: 'REAR_LEFT_INNER',
  REAR_LEFT_LCA_FWD: 'REAR_LEFT_LCA_FWD',
  REAR_LEFT_LCA_RWD: 'REAR_LEFT_LCA_RWD',
  REAR_LEFT_LOWER: 'REAR_LEFT_LOWER',
  REAR_LEFT_OUTER: 'REAR_LEFT_OUTER',
  REAR_LEFT_PUSHROD: 'REAR_LEFT_PUSHROD',
  REAR_LEFT_REARWARD: 'REAR_LEFT_REARWARD',
  REAR_LEFT_TIEROD: 'REAR_LEFT_TIEROD',
  REAR_LEFT_UCA_FWD: 'REAR_LEFT_UCA_FWD',
  REAR_LEFT_UCA_RWD: 'REAR_LEFT_UCA_RWD',
  REAR_LEFT_UPPER: 'REAR_LEFT_UPPER',
  REAR_PRIMARY: 'REAR_PRIMARY',
  REAR_RIGHT: 'REAR_RIGHT',
  REAR_RIGHT_FORWARD: 'REAR_RIGHT_FORWARD',
  REAR_RIGHT_INNER: 'REAR_RIGHT_INNER',
  REAR_RIGHT_LCA_FWD: 'REAR_RIGHT_LCA_FWD',
  REAR_RIGHT_LCA_RWD: 'REAR_RIGHT_LCA_RWD',
  REAR_RIGHT_LOWER: 'REAR_RIGHT_LOWER',
  REAR_RIGHT_OUTER: 'REAR_RIGHT_OUTER',
  REAR_RIGHT_PUSHROD: 'REAR_RIGHT_PUSHROD',
  REAR_RIGHT_REARWARD: 'REAR_RIGHT_REARWARD',
  REAR_RIGHT_TIEROD: 'REAR_RIGHT_TIEROD',
  REAR_RIGHT_UCA_FWD: 'REAR_RIGHT_UCA_FWD',
  REAR_RIGHT_UCA_RWD: 'REAR_RIGHT_UCA_RWD',
  REAR_RIGHT_UPPER: 'REAR_RIGHT_UPPER',
  REAR_SECONDARY: 'REAR_SECONDARY',
  RIGHT: 'RIGHT',
  SECONDARY: 'SECONDARY',
  SINGLE: 'SINGLE',
  STEERING_COLUMN: 'STEERING_COLUMN',
  STEERING_RACK: 'STEERING_RACK',
  STEERING_SHAFT: 'STEERING_SHAFT'
} as const;

export type EnumAssemblyTemplateRequiredPartsLocation = typeof EnumAssemblyTemplateRequiredPartsLocation[keyof typeof EnumAssemblyTemplateRequiredPartsLocation];
export const EnumAssemblyType = {
  CHASSIS: 'CHASSIS',
  SUB_ASSEMBLY: 'SUB_ASSEMBLY'
} as const;

export type EnumAssemblyType = typeof EnumAssemblyType[keyof typeof EnumAssemblyType];
export const EnumAxle = {
  FRONT: 'FRONT',
  REAR: 'REAR'
} as const;

export type EnumAxle = typeof EnumAxle[keyof typeof EnumAxle];
/** ORH will use the users timezone selection to format times accordingly */
export const EnumBehaviourConfigTimezoneSelect = {
  LAPTOP: 'LAPTOP',
  TRACK: 'TRACK',
  UTC: 'UTC'
} as const;

export type EnumBehaviourConfigTimezoneSelect = typeof EnumBehaviourConfigTimezoneSelect[keyof typeof EnumBehaviourConfigTimezoneSelect];
export const EnumBrakeBlockField = {
  POST_RUN_BRAKE_TEMPS: 'POST_RUN_BRAKE_TEMPS',
  POST_RUN_THICKNESS: 'POST_RUN_THICKNESS',
  PRE_RUN_BRAKE_TEMPS: 'PRE_RUN_BRAKE_TEMPS',
  PRE_RUN_THICKNESS: 'PRE_RUN_THICKNESS'
} as const;

export type EnumBrakeBlockField = typeof EnumBrakeBlockField[keyof typeof EnumBrakeBlockField];
export const EnumBuildSheetStyleTargetEventType = {
  AEROTEST: 'AEROTEST',
  ANY: 'ANY',
  OVAL: 'OVAL',
  ROADCOURSE: 'ROADCOURSE'
} as const;

export type EnumBuildSheetStyleTargetEventType = typeof EnumBuildSheetStyleTargetEventType[keyof typeof EnumBuildSheetStyleTargetEventType];
export const EnumBuildSheetStyleTargetRoles = {
  ADMIN: 'ADMIN',
  CAR_ENGINEER: 'CAR_ENGINEER',
  CHIEF_ENGINEER: 'CHIEF_ENGINEER',
  DRIVER: 'DRIVER',
  FAULT_ADMIN: 'FAULT_ADMIN',
  MANAGEMENT: 'MANAGEMENT',
  MECHANIC: 'MECHANIC',
  READ_ONLY: 'READ_ONLY',
  SETUP_REVIEWER: 'SETUP_REVIEWER',
  TYRE_ENGINEER: 'TYRE_ENGINEER',
  WORKSHOP_MANAGEMENT: 'WORKSHOP_MANAGEMENT'
} as const;

export type EnumBuildSheetStyleTargetRoles = typeof EnumBuildSheetStyleTargetRoles[keyof typeof EnumBuildSheetStyleTargetRoles];
export const EnumBuildSheetStyleType = {
  FULL: 'FULL',
  MINI: 'MINI',
  SIMULATION: 'SIMULATION'
} as const;

export type EnumBuildSheetStyleType = typeof EnumBuildSheetStyleType[keyof typeof EnumBuildSheetStyleType];
export const EnumBumpPlateMeasurementMethod = {
  ANGLE: 'ANGLE',
  BOTH: 'BOTH',
  LENGTH: 'LENGTH'
} as const;

export type EnumBumpPlateMeasurementMethod = typeof EnumBumpPlateMeasurementMethod[keyof typeof EnumBumpPlateMeasurementMethod];
export const EnumBumpStopGapMethod = {
  GAP_TO_BASE: 'GAP_TO_BASE',
  GAP_TO_TOP: 'GAP_TO_TOP',
  PACKER_STACK: 'PACKER_STACK'
} as const;

export type EnumBumpStopGapMethod = typeof EnumBumpStopGapMethod[keyof typeof EnumBumpStopGapMethod];
export const EnumCalculationType = {
  CAR_SETUP: 'CAR_SETUP',
  DATA_SERVICE: 'DATA_SERVICE',
  KPI: 'KPI',
  LAP: 'LAP',
  RUN_SHEET: 'RUN_SHEET'
} as const;

export type EnumCalculationType = typeof EnumCalculationType[keyof typeof EnumCalculationType];
export const EnumCanopyConfigType = {
  CAR: 'CAR',
  TRACK: 'TRACK',
  WEATHER: 'WEATHER'
} as const;

export type EnumCanopyConfigType = typeof EnumCanopyConfigType[keyof typeof EnumCanopyConfigType];
export const EnumCarDataServiceApplicationSettingsConfigRunsheetMatching = {
  DATA_INGEST: 'DATA_INGEST',
  RUNNUMBER: 'RUNNUMBER',
  STANDARD: 'STANDARD',
  TIMESTAMP: 'TIMESTAMP'
} as const;

export type EnumCarDataServiceApplicationSettingsConfigRunsheetMatching = typeof EnumCarDataServiceApplicationSettingsConfigRunsheetMatching[keyof typeof EnumCarDataServiceApplicationSettingsConfigRunsheetMatching];
export const EnumCarDataServicePitstopTriggerType = {
  EDGE: 'EDGE',
  VALUE: 'VALUE'
} as const;

export type EnumCarDataServicePitstopTriggerType = typeof EnumCarDataServicePitstopTriggerType[keyof typeof EnumCarDataServicePitstopTriggerType];
export const EnumCarDataServiceProcessingEngineConfigImporter = {
  AIM_IMPORTER: 'AIM_IMPORTER',
  ATLAS10_IMPORTER: 'ATLAS10_IMPORTER',
  ATLAS10_NOSSV_IMPORTER: 'ATLAS10_NOSSV_IMPORTER',
  ATLAS_IMPORTER: 'ATLAS_IMPORTER',
  DARAB_IMPORTER: 'DARAB_IMPORTER',
  PITOOLBOX_IMPORTER: 'PITOOLBOX_IMPORTER',
  SERVOTEST_IMPORTER: 'SERVOTEST_IMPORTER',
  TXT_IMPORTER: 'TXT_IMPORTER',
  WINTAX_IMPORTER: 'WINTAX_IMPORTER'
} as const;

export type EnumCarDataServiceProcessingEngineConfigImporter = typeof EnumCarDataServiceProcessingEngineConfigImporter[keyof typeof EnumCarDataServiceProcessingEngineConfigImporter];
export const EnumCarSetupIntendedForSession = {
  Aerotest: 'Aerotest',
  Custom: 'Custom',
  Dyno: 'Dyno',
  Free_Practice: 'Free_Practice',
  Pre_Event: 'Pre_Event',
  Qualifying: 'Qualifying',
  Race: 'Race',
  Simulation: 'Simulation',
  Test: 'Test'
} as const;

export type EnumCarSetupIntendedForSession = typeof EnumCarSetupIntendedForSession[keyof typeof EnumCarSetupIntendedForSession];
/** Override of setup sheet style, which usually comes from the chassis. */
export const EnumCarSetupSetupSheetStyle = {
  AMGGT3C190: 'AMGGT3C190',
  AMGGT3C190HRT: 'AMGGT3C190HRT',
  AMGGT4C190: 'AMGGT4C190',
  F218_2018: 'F218_2018',
  F218_2020: 'F218_2020',
  F319: 'F319',
  FLEX: 'FLEX',
  GDRIVE_ORECA_LMP2: 'GDRIVE_ORECA_LMP2',
  MBFES07: 'MBFES07',
  MCLAREN_FES09: 'MCLAREN_FES09',
  MCLAREN_XE: 'MCLAREN_XE',
  PHMT318: 'PHMT318',
  PHMT421: 'PHMT421',
  TATUUS_T318: 'TATUUS_T318',
  TATUUS_T421: 'TATUUS_T421'
} as const;

export type EnumCarSetupSetupSheetStyle = typeof EnumCarSetupSetupSheetStyle[keyof typeof EnumCarSetupSetupSheetStyle];
export const EnumChassisMeasurementsKinematicsExternalReadingsRequired = {
  CONTROL_ARM: 'CONTROL_ARM',
  CORNERS: 'CORNERS',
  CORNER_FORWARD_REARWARD: 'CORNER_FORWARD_REARWARD',
  CORNER_INNER_OUTER: 'CORNER_INNER_OUTER',
  CORNER_LOWER_UPPER: 'CORNER_LOWER_UPPER',
  FRONT_REAR: 'FRONT_REAR',
  FRONT_REAR_PRIMARY_SECONDARY: 'FRONT_REAR_PRIMARY_SECONDARY',
  INPUT_CENTER_OUTPUT: 'INPUT_CENTER_OUTPUT',
  LEFT_RIGHT: 'LEFT_RIGHT',
  POWERTRAIN: 'POWERTRAIN',
  PRIMARY_SECONDARY: 'PRIMARY_SECONDARY',
  SINGLE: 'SINGLE',
  SUSPENSION_MEMBER: 'SUSPENSION_MEMBER'
} as const;

export type EnumChassisMeasurementsKinematicsExternalReadingsRequired = typeof EnumChassisMeasurementsKinematicsExternalReadingsRequired[keyof typeof EnumChassisMeasurementsKinematicsExternalReadingsRequired];
export const EnumChassisMeasurementsKinematicsInternalReadingsRequired = {
  CONTROL_ARM: 'CONTROL_ARM',
  CORNERS: 'CORNERS',
  CORNER_FORWARD_REARWARD: 'CORNER_FORWARD_REARWARD',
  CORNER_INNER_OUTER: 'CORNER_INNER_OUTER',
  CORNER_LOWER_UPPER: 'CORNER_LOWER_UPPER',
  FRONT_REAR: 'FRONT_REAR',
  FRONT_REAR_PRIMARY_SECONDARY: 'FRONT_REAR_PRIMARY_SECONDARY',
  INPUT_CENTER_OUTPUT: 'INPUT_CENTER_OUTPUT',
  LEFT_RIGHT: 'LEFT_RIGHT',
  POWERTRAIN: 'POWERTRAIN',
  PRIMARY_SECONDARY: 'PRIMARY_SECONDARY',
  SINGLE: 'SINGLE',
  SUSPENSION_MEMBER: 'SUSPENSION_MEMBER'
} as const;

export type EnumChassisMeasurementsKinematicsInternalReadingsRequired = typeof EnumChassisMeasurementsKinematicsInternalReadingsRequired[keyof typeof EnumChassisMeasurementsKinematicsInternalReadingsRequired];
export const EnumChassisSetupSheetStyle = {
  AMGGT3C190: 'AMGGT3C190',
  AMGGT3C190HRT: 'AMGGT3C190HRT',
  AMGGT4C190: 'AMGGT4C190',
  F218_2018: 'F218_2018',
  F218_2020: 'F218_2020',
  F319: 'F319',
  FLEX: 'FLEX',
  GDRIVE_ORECA_LMP2: 'GDRIVE_ORECA_LMP2',
  MBFES07: 'MBFES07',
  MCLAREN_FES09: 'MCLAREN_FES09',
  MCLAREN_XE: 'MCLAREN_XE',
  PHMT318: 'PHMT318',
  PHMT421: 'PHMT421',
  TATUUS_T318: 'TATUUS_T318',
  TATUUS_T421: 'TATUUS_T421'
} as const;

export type EnumChassisSetupSheetStyle = typeof EnumChassisSetupSheetStyle[keyof typeof EnumChassisSetupSheetStyle];
export const EnumCommentBlockField = {
  brakeComment: 'brakeComment',
  controlsComment: 'controlsComment',
  dilComments: 'dilComments',
  driverComments: 'driverComments',
  engineerComments: 'engineerComments',
  performanceComments: 'performanceComments',
  problemComments: 'problemComments',
  runDescription: 'runDescription',
  skidComment: 'skidComment',
  summaryComments: 'summaryComments',
  systemsComments: 'systemsComments',
  tyreComments: 'tyreComments'
} as const;

export type EnumCommentBlockField = typeof EnumCommentBlockField[keyof typeof EnumCommentBlockField];
export const EnumComplianceUnit = {
  INCHES_PER_POUND_FORCE: 'INCHES_PER_POUND_FORCE',
  METRES_PER_NEWTON: 'METRES_PER_NEWTON',
  MILLIMETRES_PER_NEWTON: 'MILLIMETRES_PER_NEWTON'
} as const;

export type EnumComplianceUnit = typeof EnumComplianceUnit[keyof typeof EnumComplianceUnit];
export const EnumCustomSpecReadingsRequired = {
  CONTROL_ARM: 'CONTROL_ARM',
  CORNERS: 'CORNERS',
  CORNER_FORWARD_REARWARD: 'CORNER_FORWARD_REARWARD',
  CORNER_INNER_OUTER: 'CORNER_INNER_OUTER',
  CORNER_LOWER_UPPER: 'CORNER_LOWER_UPPER',
  FRONT_REAR: 'FRONT_REAR',
  FRONT_REAR_PRIMARY_SECONDARY: 'FRONT_REAR_PRIMARY_SECONDARY',
  INPUT_CENTER_OUTPUT: 'INPUT_CENTER_OUTPUT',
  LEFT_RIGHT: 'LEFT_RIGHT',
  POWERTRAIN: 'POWERTRAIN',
  PRIMARY_SECONDARY: 'PRIMARY_SECONDARY',
  SINGLE: 'SINGLE',
  SUSPENSION_MEMBER: 'SUSPENSION_MEMBER'
} as const;

export type EnumCustomSpecReadingsRequired = typeof EnumCustomSpecReadingsRequired[keyof typeof EnumCustomSpecReadingsRequired];
export const EnumDataCheck = {
  ASSEMBLY_IDS_NULL: 'ASSEMBLY_IDS_NULL'
} as const;

export type EnumDataCheck = typeof EnumDataCheck[keyof typeof EnumDataCheck];
export const EnumDisplayUnit = {
  BAR: 'BAR',
  CELSIUS: 'CELSIUS',
  CENTIMETRES: 'CENTIMETRES',
  DAYS: 'DAYS',
  DEGREES: 'DEGREES',
  DEGREES_PER_FOOT_POUND: 'DEGREES_PER_FOOT_POUND',
  DEGREES_PER_INCHES: 'DEGREES_PER_INCHES',
  DEGREES_PER_MILLIMETRES: 'DEGREES_PER_MILLIMETRES',
  DEGREES_PER_POUND: 'DEGREES_PER_POUND',
  DEGREES_PER_SECOND: 'DEGREES_PER_SECOND',
  DEGREES_PER_SECOND_SQUARED: 'DEGREES_PER_SECOND_SQUARED',
  FAHRENHEIT: 'FAHRENHEIT',
  FEET: 'FEET',
  FEET_PER_SECOND: 'FEET_PER_SECOND',
  FEET_PER_SECOND_SQUARED: 'FEET_PER_SECOND_SQUARED',
  GALLONS: 'GALLONS',
  GFORCE: 'GFORCE',
  GRAMS: 'GRAMS',
  HORSEPOWER_MECHANICAL: 'HORSEPOWER_MECHANICAL',
  HOURS: 'HOURS',
  INCHES: 'INCHES',
  INCHES_OF_MERCURY: 'INCHES_OF_MERCURY',
  INCHES_PER_POUND_FORCE: 'INCHES_PER_POUND_FORCE',
  JOULES: 'JOULES',
  KELVIN: 'KELVIN',
  KILOGRAMS: 'KILOGRAMS',
  KILOGRAM_METRES_SQUARED: 'KILOGRAM_METRES_SQUARED',
  KILOJOULES: 'KILOJOULES',
  KILOMETRES: 'KILOMETRES',
  KILOMETRES_PER_HOUR: 'KILOMETRES_PER_HOUR',
  KILOPASCALS: 'KILOPASCALS',
  KILOWATTS: 'KILOWATTS',
  KILOWATT_HOURS: 'KILOWATT_HOURS',
  LITRES: 'LITRES',
  METRES: 'METRES',
  METRES_CUBED: 'METRES_CUBED',
  METRES_PER_NEWTON: 'METRES_PER_NEWTON',
  METRES_PER_SECOND: 'METRES_PER_SECOND',
  METRES_PER_SECOND_SQUARED: 'METRES_PER_SECOND_SQUARED',
  MICROMETRES: 'MICROMETRES',
  MILES: 'MILES',
  MILES_PER_HOUR: 'MILES_PER_HOUR',
  MILLIBAR: 'MILLIBAR',
  MILLIGRAMS: 'MILLIGRAMS',
  MILLILITRES: 'MILLILITRES',
  MILLIMETRES: 'MILLIMETRES',
  MILLIMETRES_PER_NEWTON: 'MILLIMETRES_PER_NEWTON',
  MILLISECONDS: 'MILLISECONDS',
  MINUTES: 'MINUTES',
  NEWTONS: 'NEWTONS',
  NEWTONS_PER_METRE: 'NEWTONS_PER_METRE',
  NEWTONS_PER_MILLIMETRE: 'NEWTONS_PER_MILLIMETRE',
  NEWTON_METRES: 'NEWTON_METRES',
  NEWTON_METRES_PER_DEGREE: 'NEWTON_METRES_PER_DEGREE',
  NEWTON_METRES_PER_RADIAN: 'NEWTON_METRES_PER_RADIAN',
  NEWTON_MILLIMETRES: 'NEWTON_MILLIMETRES',
  NONE: 'NONE',
  NUMBER: 'NUMBER',
  OUNCES: 'OUNCES',
  PASCALS: 'PASCALS',
  PERCENT: 'PERCENT',
  POUNDS: 'POUNDS',
  POUNDS_FEET_PER_DEGREE: 'POUNDS_FEET_PER_DEGREE',
  POUNDS_FEET_PER_RADIAN: 'POUNDS_FEET_PER_RADIAN',
  POUNDS_FORCE: 'POUNDS_FORCE',
  POUNDS_INCHES_PER_DEGREE: 'POUNDS_INCHES_PER_DEGREE',
  POUNDS_INCHES_PER_RADIAN: 'POUNDS_INCHES_PER_RADIAN',
  POUNDS_PER_INCH: 'POUNDS_PER_INCH',
  POUND_FOOT_ENERGY: 'POUND_FOOT_ENERGY',
  POUND_FOOT_SECONDS_SQUARED: 'POUND_FOOT_SECONDS_SQUARED',
  POUND_FORCE_FEET: 'POUND_FORCE_FEET',
  POUND_FORCE_INCHES: 'POUND_FORCE_INCHES',
  PSI: 'PSI',
  RADIANS: 'RADIANS',
  RADIANS_PER_NEWTON: 'RADIANS_PER_NEWTON',
  RADIANS_PER_NEWTON_METRE: 'RADIANS_PER_NEWTON_METRE',
  RADIANS_PER_SECOND: 'RADIANS_PER_SECOND',
  RADIANS_PER_SECOND_SQUARED: 'RADIANS_PER_SECOND_SQUARED',
  RATIO: 'RATIO',
  SECONDS: 'SECONDS',
  STRING: 'STRING',
  THOU: 'THOU',
  WATTS: 'WATTS'
} as const;

export type EnumDisplayUnit = typeof EnumDisplayUnit[keyof typeof EnumDisplayUnit];
export const EnumElasticType = {
  BUMP_RUBBER: 'BUMP_RUBBER',
  HELPER_SPRING: 'HELPER_SPRING',
  REBOUND_SPRING: 'REBOUND_SPRING',
  SPRING: 'SPRING',
  TORSION_BAR: 'TORSION_BAR'
} as const;

export type EnumElasticType = typeof EnumElasticType[keyof typeof EnumElasticType];
export const EnumEnergyType = {
  COMBUSTION: 'COMBUSTION',
  ELECTRIC: 'ELECTRIC'
} as const;

export type EnumEnergyType = typeof EnumEnergyType[keyof typeof EnumEnergyType];
export const EnumEnergyUnit = {
  JOULES: 'JOULES',
  KILOJOULES: 'KILOJOULES',
  KILOWATT_HOURS: 'KILOWATT_HOURS',
  POUND_FOOT_ENERGY: 'POUND_FOOT_ENERGY'
} as const;

export type EnumEnergyUnit = typeof EnumEnergyUnit[keyof typeof EnumEnergyUnit];
export const EnumEventDebriefNotesMode = {
  markdown: 'markdown',
  table: 'table'
} as const;

export type EnumEventDebriefNotesMode = typeof EnumEventDebriefNotesMode[keyof typeof EnumEventDebriefNotesMode];
export const EnumEventEnumEventType = {
  AERO: 'AERO',
  DYNO: 'DYNO',
  MEDIA: 'MEDIA',
  OTHER: 'OTHER',
  RACE: 'RACE',
  SIMULATOR: 'SIMULATOR',
  TEST: 'TEST'
} as const;

export type EnumEventEnumEventType = typeof EnumEventEnumEventType[keyof typeof EnumEventEnumEventType];
export const EnumEventEnumEventVenue = {
  DIRT: 'DIRT',
  DYNO: 'DYNO',
  OTHER: 'OTHER',
  OVAL: 'OVAL',
  TRACK: 'TRACK'
} as const;

export type EnumEventEnumEventVenue = typeof EnumEventEnumEventVenue[keyof typeof EnumEventEnumEventVenue];
export const EnumEventReferenceLaptimesCalculationMethod = {
  RATIO: 'RATIO',
  TIME: 'TIME'
} as const;

export type EnumEventReferenceLaptimesCalculationMethod = typeof EnumEventReferenceLaptimesCalculationMethod[keyof typeof EnumEventReferenceLaptimesCalculationMethod];
export const EnumEventType = {
  AERO: 'AERO',
  DYNO: 'DYNO',
  MEDIA: 'MEDIA',
  OTHER: 'OTHER',
  RACE: 'RACE',
  SIMULATOR: 'SIMULATOR',
  TEST: 'TEST'
} as const;

export type EnumEventType = typeof EnumEventType[keyof typeof EnumEventType];
export const EnumFlexLayoutConfigGlobalXAxisType = {
  DATA: 'DATA',
  TIME: 'TIME'
} as const;

export type EnumFlexLayoutConfigGlobalXAxisType = typeof EnumFlexLayoutConfigGlobalXAxisType[keyof typeof EnumFlexLayoutConfigGlobalXAxisType];
export const EnumFlexLayoutConfigIntendedFor = {
  BOP: 'BOP',
  KPI: 'KPI',
  REPORT: 'REPORT',
  RUNSHEET: 'RUNSHEET',
  SETUPOVERVIEW: 'SETUPOVERVIEW',
  SETUPSANDBOX: 'SETUPSANDBOX',
  SETUPSHEET: 'SETUPSHEET',
  SIMULATION: 'SIMULATION'
} as const;

export type EnumFlexLayoutConfigIntendedFor = typeof EnumFlexLayoutConfigIntendedFor[keyof typeof EnumFlexLayoutConfigIntendedFor];
export const EnumForceUnit = {
  NEWTONS: 'NEWTONS',
  POUNDS_FORCE: 'POUNDS_FORCE'
} as const;

export type EnumForceUnit = typeof EnumForceUnit[keyof typeof EnumForceUnit];
export const EnumFuelColumn = {
  ENERGY_TYPE: 'ENERGY_TYPE',
  EXTENDED_CONSUMPTION: 'EXTENDED_CONSUMPTION',
  FUEL_DENSITY: 'FUEL_DENSITY'
} as const;

export type EnumFuelColumn = typeof EnumFuelColumn[keyof typeof EnumFuelColumn];
export const EnumGearType = {
  BEVEL_SET: 'BEVEL_SET',
  DROP_GEAR: 'DROP_GEAR',
  STANDARD: 'STANDARD'
} as const;

export type EnumGearType = typeof EnumGearType[keyof typeof EnumGearType];
export const EnumGenericRunSheetStyleBlockEnergyFieldOrder = {
  ATTACK: 'ATTACK',
  COOL: 'COOL',
  FCY: 'FCY',
  IN: 'IN',
  OUT: 'OUT',
  OUTIN: 'OUTIN',
  PITLANE: 'PITLANE',
  PREP: 'PREP',
  PUSH: 'PUSH',
  QUALI: 'QUALI',
  SAFETYCAR: 'SAFETYCAR',
  SHAKEDOWN: 'SHAKEDOWN',
  SLOW: 'SLOW',
  TARGET: 'TARGET',
  TOGRID: 'TOGRID',
  TOPADDOCK: 'TOPADDOCK',
  TOPITS: 'TOPITS',
  UNFINISHED: 'UNFINISHED'
} as const;

export type EnumGenericRunSheetStyleBlockEnergyFieldOrder = typeof EnumGenericRunSheetStyleBlockEnergyFieldOrder[keyof typeof EnumGenericRunSheetStyleBlockEnergyFieldOrder];
export const EnumGenericRunSheetStyleBlockLapCountBlockFieldOrderField = {
  ATTACK: 'ATTACK',
  COOL: 'COOL',
  FCY: 'FCY',
  GREEN: 'GREEN',
  IN: 'IN',
  NOTGREEN: 'NOTGREEN',
  OUT: 'OUT',
  OUTIN: 'OUTIN',
  PITLANE: 'PITLANE',
  PREP: 'PREP',
  PUSH: 'PUSH',
  QUALI: 'QUALI',
  SAFETYCAR: 'SAFETYCAR',
  SHAKEDOWN: 'SHAKEDOWN',
  SLOW: 'SLOW',
  TARGET: 'TARGET',
  TOGRID: 'TOGRID',
  TOPADDOCK: 'TOPADDOCK',
  TOPITS: 'TOPITS',
  UNFINISHED: 'UNFINISHED'
} as const;

export type EnumGenericRunSheetStyleBlockLapCountBlockFieldOrderField = typeof EnumGenericRunSheetStyleBlockLapCountBlockFieldOrderField[keyof typeof EnumGenericRunSheetStyleBlockLapCountBlockFieldOrderField];
export const EnumGenericRunSheetStyleBlockType = {
  BLANKING: 'BLANKING',
  BRAKES: 'BRAKES',
  COMMENT: 'COMMENT',
  DOUBLE_COMMENT: 'DOUBLE_COMMENT',
  FUEL: 'FUEL',
  ISSUE: 'ISSUE',
  JOB_LIST: 'JOB_LIST',
  LAP_TABLE: 'LAP_TABLE',
  LAP_TIME_THRESHOLDS: 'LAP_TIME_THRESHOLDS',
  LAP_TYPE_COUNT: 'LAP_TYPE_COUNT',
  MINI_JOBLIST: 'MINI_JOBLIST',
  POST_RUN_MEASUREMENT: 'POST_RUN_MEASUREMENT',
  RUN_KPI_TABLE: 'RUN_KPI_TABLE',
  SETUP_CHANGES: 'SETUP_CHANGES',
  SETUP_SHEET: 'SETUP_SHEET',
  TYRE_TABLE: 'TYRE_TABLE',
  WEATHER_BOX: 'WEATHER_BOX'
} as const;

export type EnumGenericRunSheetStyleBlockType = typeof EnumGenericRunSheetStyleBlockType[keyof typeof EnumGenericRunSheetStyleBlockType];
/** Only "Point" is supported */
export const EnumGeoLocationType = {
  Point: 'Point'
} as const;

export type EnumGeoLocationType = typeof EnumGeoLocationType[keyof typeof EnumGeoLocationType];
export const EnumHistoryType = {
  CARSETUP: 'CARSETUP',
  RUNSHEET: 'RUNSHEET'
} as const;

export type EnumHistoryType = typeof EnumHistoryType[keyof typeof EnumHistoryType];
export const EnumInertiaUnit = {
  KILOGRAM_METRES_SQUARED: 'KILOGRAM_METRES_SQUARED',
  POUND_FOOT_SECONDS_SQUARED: 'POUND_FOOT_SECONDS_SQUARED'
} as const;

export type EnumInertiaUnit = typeof EnumInertiaUnit[keyof typeof EnumInertiaUnit];
export const EnumIssueIssueStatus = {
  CLOSED: 'CLOSED',
  CLOSURE_REQUESTED: 'CLOSURE_REQUESTED',
  CONTAINED_BY_DESIGN: 'CONTAINED_BY_DESIGN',
  CONTAINED_BY_OPERATIONS: 'CONTAINED_BY_OPERATIONS',
  CONTAINED_BY_PROCESS: 'CONTAINED_BY_PROCESS',
  OPEN: 'OPEN',
  RESPONSIBLE_ASSIGNED: 'RESPONSIBLE_ASSIGNED'
} as const;

export type EnumIssueIssueStatus = typeof EnumIssueIssueStatus[keyof typeof EnumIssueIssueStatus];
export const EnumIssuePriority = {
  HIGH: 'HIGH',
  LOW: 'LOW',
  MAXIMUM: 'MAXIMUM',
  MEDIUM: 'MEDIUM',
  NONE: 'NONE',
  PRIO1_MAXIMUM: 'PRIO1_MAXIMUM',
  PRIO2_HIGH: 'PRIO2_HIGH',
  PRIO3_MEDIUM: 'PRIO3_MEDIUM',
  PRIO4_LOW: 'PRIO4_LOW',
  PRIO5_NONE: 'PRIO5_NONE'
} as const;

export type EnumIssuePriority = typeof EnumIssuePriority[keyof typeof EnumIssuePriority];
export const EnumIssueQueryIssueStatus = {
  CLOSED: 'CLOSED',
  CLOSURE_REQUESTED: 'CLOSURE_REQUESTED',
  CONTAINED_BY_DESIGN: 'CONTAINED_BY_DESIGN',
  CONTAINED_BY_OPERATIONS: 'CONTAINED_BY_OPERATIONS',
  CONTAINED_BY_PROCESS: 'CONTAINED_BY_PROCESS',
  OPEN: 'OPEN',
  RESPONSIBLE_ASSIGNED: 'RESPONSIBLE_ASSIGNED'
} as const;

export type EnumIssueQueryIssueStatus = typeof EnumIssueQueryIssueStatus[keyof typeof EnumIssueQueryIssueStatus];
export const EnumIssueQueryPriority = {
  HIGH: 'HIGH',
  LOW: 'LOW',
  MAXIMUM: 'MAXIMUM',
  MEDIUM: 'MEDIUM',
  NONE: 'NONE',
  PRIO1_MAXIMUM: 'PRIO1_MAXIMUM',
  PRIO2_HIGH: 'PRIO2_HIGH',
  PRIO3_MEDIUM: 'PRIO3_MEDIUM',
  PRIO4_LOW: 'PRIO4_LOW',
  PRIO5_NONE: 'PRIO5_NONE'
} as const;

export type EnumIssueQueryPriority = typeof EnumIssueQueryPriority[keyof typeof EnumIssueQueryPriority];
export const EnumJobPriority = {
  HIGH: 'HIGH',
  LOW: 'LOW',
  MAXIMUM: 'MAXIMUM',
  MEDIUM: 'MEDIUM',
  NONE: 'NONE',
  PRIO1_MAXIMUM: 'PRIO1_MAXIMUM',
  PRIO2_HIGH: 'PRIO2_HIGH',
  PRIO3_MEDIUM: 'PRIO3_MEDIUM',
  PRIO4_LOW: 'PRIO4_LOW',
  PRIO5_NONE: 'PRIO5_NONE'
} as const;

export type EnumJobPriority = typeof EnumJobPriority[keyof typeof EnumJobPriority];
/** If job is intended as a sub-task then it either belongs to an Issue or a Job. This field prevents making unnecesary database calls when assigning the sub-tasks' ID to it's parent */
export const EnumJobTarget = {
  ISSUE: 'ISSUE',
  JOB: 'JOB',
  JOB_SUBTASK: 'JOB_SUBTASK'
} as const;

export type EnumJobTarget = typeof EnumJobTarget[keyof typeof EnumJobTarget];
export const EnumKinematicsInternalReference = {
  DROOP: 'DROOP',
  FORCE: 'FORCE',
  REF: 'REF',
  STATIC: 'STATIC'
} as const;

export type EnumKinematicsInternalReference = typeof EnumKinematicsInternalReference[keyof typeof EnumKinematicsInternalReference];
export const EnumLapColumnField = {
  DAYTIME: 'DAYTIME',
  DRIVER_CALLOUT: 'DRIVER_CALLOUT',
  DRIVER_CALLOUT2: 'DRIVER_CALLOUT2',
  ENERGY_CONSUMPTION_LAP: 'ENERGY_CONSUMPTION_LAP',
  ENERGY_LAP_DATA: 'ENERGY_LAP_DATA',
  ENERGY_LAP_END: 'ENERGY_LAP_END',
  ENERGY_LAP_END_DATA: 'ENERGY_LAP_END_DATA',
  ENERGY_LAP_START: 'ENERGY_LAP_START',
  ENERGY_REMAINING_PUSH_LAP: 'ENERGY_REMAINING_PUSH_LAP',
  FUEL_CONSUMPTION_LAP: 'FUEL_CONSUMPTION_LAP',
  FUEL_LAP_DATA: 'FUEL_LAP_DATA',
  FUEL_LAP_END: 'FUEL_LAP_END',
  FUEL_LAP_END_DATA: 'FUEL_LAP_END_DATA',
  FUEL_LAP_START: 'FUEL_LAP_START',
  FUEL_REMAINING_PUSH_LAP: 'FUEL_REMAINING_PUSH_LAP',
  FUEL_VOLUME_CONSUMPTION_LAP: 'FUEL_VOLUME_CONSUMPTION_LAP',
  FUEL_VOLUME_LAP_END: 'FUEL_VOLUME_LAP_END',
  FUEL_VOLUME_LAP_START: 'FUEL_VOLUME_LAP_START',
  FUEL_VOLUME_REMAINING_PUSH_LAP: 'FUEL_VOLUME_REMAINING_PUSH_LAP',
  LAPCOMMENT: 'LAPCOMMENT',
  LAPCOMMENTSYSTEMS: 'LAPCOMMENTSYSTEMS',
  LAPKPI: 'LAPKPI',
  LAPTIME: 'LAPTIME',
  LAPTYPE: 'LAPTYPE',
  NLAPRUN: 'NLAPRUN',
  NLAPSESSION: 'NLAPSESSION',
  NLAPSTINT: 'NLAPSTINT',
  POSITION: 'POSITION',
  POWER_MODE: 'POWER_MODE',
  RACECONTROLMESSAGE: 'RACECONTROLMESSAGE',
  SECTORSPEEDS: 'SECTORSPEEDS',
  SECTORTIMES: 'SECTORTIMES',
  SESSION_TIME_REMAINING: 'SESSION_TIME_REMAINING',
  SOC_CONSUMPTION_LAP: 'SOC_CONSUMPTION_LAP',
  SOC_LAP_DATA: 'SOC_LAP_DATA',
  SOC_LAP_END: 'SOC_LAP_END',
  SOC_LAP_END_DATA: 'SOC_LAP_END_DATA',
  SOC_LAP_START: 'SOC_LAP_START',
  SOC_REMAINING_PUSH_LAP: 'SOC_REMAINING_PUSH_LAP',
  TCELL: 'TCELL',
  TOPSPEED: 'TOPSPEED',
  TRACK_LAYOUT: 'TRACK_LAYOUT',
  TYRECOMPOUND: 'TYRECOMPOUND'
} as const;

export type EnumLapColumnField = typeof EnumLapColumnField[keyof typeof EnumLapColumnField];
/** Source of the lap data */
export const EnumLapDataSource = {
  CAR_DATA_SERVICE: 'CAR_DATA_SERVICE',
  LAPTIME_SERVICE: 'LAPTIME_SERVICE',
  MANUAL: 'MANUAL'
} as const;

export type EnumLapDataSource = typeof EnumLapDataSource[keyof typeof EnumLapDataSource];
export const EnumLapDataSourceType = {
  CAR_DATA_SERVICE: 'CAR_DATA_SERVICE',
  LAPTIME_SERVICE: 'LAPTIME_SERVICE',
  MANUAL: 'MANUAL'
} as const;

export type EnumLapDataSourceType = typeof EnumLapDataSourceType[keyof typeof EnumLapDataSourceType];
export const EnumLapSequenceLapsLapType = {
  ATTACK: 'ATTACK',
  COOL: 'COOL',
  FCY: 'FCY',
  IN: 'IN',
  OUT: 'OUT',
  OUTIN: 'OUTIN',
  PITLANE: 'PITLANE',
  PREP: 'PREP',
  PUSH: 'PUSH',
  QUALI: 'QUALI',
  SAFETYCAR: 'SAFETYCAR',
  SHAKEDOWN: 'SHAKEDOWN',
  SLOW: 'SLOW',
  TARGET: 'TARGET',
  TOGRID: 'TOGRID',
  TOPADDOCK: 'TOPADDOCK',
  TOPITS: 'TOPITS',
  UNFINISHED: 'UNFINISHED'
} as const;

export type EnumLapSequenceLapsLapType = typeof EnumLapSequenceLapsLapType[keyof typeof EnumLapSequenceLapsLapType];
export const EnumLapSequenceTemplateLapsLapType = {
  ATTACK_LAP: 'ATTACK_LAP',
  GARAGE: 'GARAGE',
  PREP_LAP: 'PREP_LAP',
  PUSH: 'PUSH',
  QUALI: 'QUALI',
  SLOW_LAP: 'SLOW_LAP',
  TARGET_LAP: 'TARGET_LAP',
  WAIT: 'WAIT'
} as const;

export type EnumLapSequenceTemplateLapsLapType = typeof EnumLapSequenceTemplateLapsLapType[keyof typeof EnumLapSequenceTemplateLapsLapType];
export const EnumLapType = {
  ATTACK: 'ATTACK',
  COOL: 'COOL',
  FCY: 'FCY',
  IN: 'IN',
  OUT: 'OUT',
  OUTIN: 'OUTIN',
  PITLANE: 'PITLANE',
  PREP: 'PREP',
  PUSH: 'PUSH',
  QUALI: 'QUALI',
  SAFETYCAR: 'SAFETYCAR',
  SHAKEDOWN: 'SHAKEDOWN',
  SLOW: 'SLOW',
  TARGET: 'TARGET',
  TOGRID: 'TOGRID',
  TOPADDOCK: 'TOPADDOCK',
  TOPITS: 'TOPITS',
  UNFINISHED: 'UNFINISHED'
} as const;

export type EnumLapType = typeof EnumLapType[keyof typeof EnumLapType];
export const EnumLengthUnit = {
  CENTIMETRES: 'CENTIMETRES',
  FEET: 'FEET',
  INCHES: 'INCHES',
  KILOMETRES: 'KILOMETRES',
  METRES: 'METRES',
  MICROMETRES: 'MICROMETRES',
  MILES: 'MILES',
  MILLIMETRES: 'MILLIMETRES',
  THOU: 'THOU'
} as const;

export type EnumLengthUnit = typeof EnumLengthUnit[keyof typeof EnumLengthUnit];
export const EnumLineStyle = {
  DASHED: 'DASHED',
  DASH_DOT: 'DASH_DOT',
  DOTTED: 'DOTTED',
  NONE: 'NONE',
  SOLID: 'SOLID'
} as const;

export type EnumLineStyle = typeof EnumLineStyle[keyof typeof EnumLineStyle];
export const EnumLiveStandingCurrentLocation = {
  PIT: 'PIT',
  TRACK: 'TRACK'
} as const;

export type EnumLiveStandingCurrentLocation = typeof EnumLiveStandingCurrentLocation[keyof typeof EnumLiveStandingCurrentLocation];
export const EnumLocalConnectionDataMapping = {
  Flat: 'Flat',
  Standard: 'Standard'
} as const;

export type EnumLocalConnectionDataMapping = typeof EnumLocalConnectionDataMapping[keyof typeof EnumLocalConnectionDataMapping];
export const EnumLogLevel = {
  CRITICAL: 'CRITICAL',
  DEBUG: 'DEBUG',
  ERROR: 'ERROR',
  INFO: 'INFO',
  WARNING: 'WARNING'
} as const;

export type EnumLogLevel = typeof EnumLogLevel[keyof typeof EnumLogLevel];
export const EnumLogLogLevel = {
  CRITICAL: 'CRITICAL',
  DEBUG: 'DEBUG',
  ERROR: 'ERROR',
  INFO: 'INFO',
  WARNING: 'WARNING'
} as const;

export type EnumLogLogLevel = typeof EnumLogLogLevel[keyof typeof EnumLogLogLevel];
export const EnumLogServiceSource = {
  CANOPY: 'CANOPY',
  CUSTOM_SIMULATION: 'CUSTOM_SIMULATION',
  TIMING: 'TIMING',
  WEATHER_STATION: 'WEATHER_STATION'
} as const;

export type EnumLogServiceSource = typeof EnumLogServiceSource[keyof typeof EnumLogServiceSource];
export const EnumMarkerStyle = {
  CIRCLE: 'CIRCLE',
  DIAMOND: 'DIAMOND',
  HEXAGON: 'HEXAGON',
  NONE: 'NONE',
  PENTAGON: 'PENTAGON',
  SQUARE: 'SQUARE',
  TRIANGLE: 'TRIANGLE',
  X_MARK: 'X_MARK'
} as const;

export type EnumMarkerStyle = typeof EnumMarkerStyle[keyof typeof EnumMarkerStyle];
export const EnumMassUnit = {
  GRAMS: 'GRAMS',
  KILOGRAMS: 'KILOGRAMS',
  MILLIGRAMS: 'MILLIGRAMS',
  OUNCES: 'OUNCES',
  POUNDS: 'POUNDS'
} as const;

export type EnumMassUnit = typeof EnumMassUnit[keyof typeof EnumMassUnit];
export const EnumMeCarUpdateMethod = {
  FORWARD_PROPAGATE: 'FORWARD_PROPAGATE',
  STANDARD: 'STANDARD'
} as const;

export type EnumMeCarUpdateMethod = typeof EnumMeCarUpdateMethod[keyof typeof EnumMeCarUpdateMethod];
export const EnumMigration = {
  carSetupMissingTitle: 'carSetupMissingTitle',
  eventContestantsDedup: 'eventContestantsDedup',
  issuePriority: 'issuePriority',
  lapPitOutAndInTimeStamps: 'lapPitOutAndInTimeStamps',
  lapSessionID: 'lapSessionID',
  lapsToCollection: 'lapsToCollection',
  manualMileageCustomToCarSetup: 'manualMileageCustomToCarSetup',
  readingsAllowableDamperElasticSpec: 'readingsAllowableDamperElasticSpec',
  rootSpecificationID: 'rootSpecificationID',
  runDistanceTrackingItemsCumulativeCalculation: 'runDistanceTrackingItemsCumulativeCalculation',
  runSheetAndLapTimeStamps: 'runSheetAndLapTimeStamps',
  sessionTypeToEnum: 'sessionTypeToEnum',
  setupSheetStyleTabs: 'setupSheetStyleTabs',
  setupTimingServiceStatus: 'setupTimingServiceStatus',
  teamsToTeamIDsOnPart: 'teamsToTeamIDsOnPart',
  trackingSourcesAndItems: 'trackingSourcesAndItems',
  trackingUpdate202506: 'trackingUpdate202506'
} as const;

export type EnumMigration = typeof EnumMigration[keyof typeof EnumMigration];
export const EnumOneTimingWeatherServiceConfigLogLevel = {
  CRITICAL: 'CRITICAL',
  DEBUG: 'DEBUG',
  ERROR: 'ERROR',
  INFO: 'INFO',
  NOTSET: 'NOTSET',
  WARNING: 'WARNING'
} as const;

export type EnumOneTimingWeatherServiceConfigLogLevel = typeof EnumOneTimingWeatherServiceConfigLogLevel[keyof typeof EnumOneTimingWeatherServiceConfigLogLevel];
export const EnumPackageMethod = {
  DELTA: 'DELTA',
  VALUE: 'VALUE'
} as const;

export type EnumPackageMethod = typeof EnumPackageMethod[keyof typeof EnumPackageMethod];
export const EnumPartEligibleEventTypes = {
  AERO: 'AERO',
  ALL: 'ALL',
  DYNO: 'DYNO',
  MEDIA: 'MEDIA',
  OTHER: 'OTHER',
  RACE: 'RACE',
  SIMULATOR: 'SIMULATOR',
  TEST: 'TEST'
} as const;

export type EnumPartEligibleEventTypes = typeof EnumPartEligibleEventTypes[keyof typeof EnumPartEligibleEventTypes];
export const EnumPartReadingLocationOverride = {
  CENTER: 'CENTER',
  ENGINE_IN: 'ENGINE_IN',
  ENGINE_OUT: 'ENGINE_OUT',
  FRONT: 'FRONT',
  FRONT_LEFT: 'FRONT_LEFT',
  FRONT_LEFT_FORWARD: 'FRONT_LEFT_FORWARD',
  FRONT_LEFT_INNER: 'FRONT_LEFT_INNER',
  FRONT_LEFT_LCA_FWD: 'FRONT_LEFT_LCA_FWD',
  FRONT_LEFT_LCA_RWD: 'FRONT_LEFT_LCA_RWD',
  FRONT_LEFT_LOWER: 'FRONT_LEFT_LOWER',
  FRONT_LEFT_OUTER: 'FRONT_LEFT_OUTER',
  FRONT_LEFT_PUSHROD: 'FRONT_LEFT_PUSHROD',
  FRONT_LEFT_REARWARD: 'FRONT_LEFT_REARWARD',
  FRONT_LEFT_TIEROD: 'FRONT_LEFT_TIEROD',
  FRONT_LEFT_UCA_FWD: 'FRONT_LEFT_UCA_FWD',
  FRONT_LEFT_UCA_RWD: 'FRONT_LEFT_UCA_RWD',
  FRONT_LEFT_UPPER: 'FRONT_LEFT_UPPER',
  FRONT_PRIMARY: 'FRONT_PRIMARY',
  FRONT_RIGHT: 'FRONT_RIGHT',
  FRONT_RIGHT_FORWARD: 'FRONT_RIGHT_FORWARD',
  FRONT_RIGHT_INNER: 'FRONT_RIGHT_INNER',
  FRONT_RIGHT_LCA_FWD: 'FRONT_RIGHT_LCA_FWD',
  FRONT_RIGHT_LCA_RWD: 'FRONT_RIGHT_LCA_RWD',
  FRONT_RIGHT_LOWER: 'FRONT_RIGHT_LOWER',
  FRONT_RIGHT_OUTER: 'FRONT_RIGHT_OUTER',
  FRONT_RIGHT_PUSHROD: 'FRONT_RIGHT_PUSHROD',
  FRONT_RIGHT_REARWARD: 'FRONT_RIGHT_REARWARD',
  FRONT_RIGHT_TIEROD: 'FRONT_RIGHT_TIEROD',
  FRONT_RIGHT_UCA_FWD: 'FRONT_RIGHT_UCA_FWD',
  FRONT_RIGHT_UCA_RWD: 'FRONT_RIGHT_UCA_RWD',
  FRONT_RIGHT_UPPER: 'FRONT_RIGHT_UPPER',
  FRONT_SECONDARY: 'FRONT_SECONDARY',
  GBX_IN: 'GBX_IN',
  GBX_OUT: 'GBX_OUT',
  INPUT: 'INPUT',
  LEFT: 'LEFT',
  MGU_IN: 'MGU_IN',
  MGU_OUT: 'MGU_OUT',
  OUTPUT: 'OUTPUT',
  PRIMARY: 'PRIMARY',
  REAR: 'REAR',
  REAR_LEFT: 'REAR_LEFT',
  REAR_LEFT_FORWARD: 'REAR_LEFT_FORWARD',
  REAR_LEFT_INNER: 'REAR_LEFT_INNER',
  REAR_LEFT_LCA_FWD: 'REAR_LEFT_LCA_FWD',
  REAR_LEFT_LCA_RWD: 'REAR_LEFT_LCA_RWD',
  REAR_LEFT_LOWER: 'REAR_LEFT_LOWER',
  REAR_LEFT_OUTER: 'REAR_LEFT_OUTER',
  REAR_LEFT_PUSHROD: 'REAR_LEFT_PUSHROD',
  REAR_LEFT_REARWARD: 'REAR_LEFT_REARWARD',
  REAR_LEFT_TIEROD: 'REAR_LEFT_TIEROD',
  REAR_LEFT_UCA_FWD: 'REAR_LEFT_UCA_FWD',
  REAR_LEFT_UCA_RWD: 'REAR_LEFT_UCA_RWD',
  REAR_LEFT_UPPER: 'REAR_LEFT_UPPER',
  REAR_PRIMARY: 'REAR_PRIMARY',
  REAR_RIGHT: 'REAR_RIGHT',
  REAR_RIGHT_FORWARD: 'REAR_RIGHT_FORWARD',
  REAR_RIGHT_INNER: 'REAR_RIGHT_INNER',
  REAR_RIGHT_LCA_FWD: 'REAR_RIGHT_LCA_FWD',
  REAR_RIGHT_LCA_RWD: 'REAR_RIGHT_LCA_RWD',
  REAR_RIGHT_LOWER: 'REAR_RIGHT_LOWER',
  REAR_RIGHT_OUTER: 'REAR_RIGHT_OUTER',
  REAR_RIGHT_PUSHROD: 'REAR_RIGHT_PUSHROD',
  REAR_RIGHT_REARWARD: 'REAR_RIGHT_REARWARD',
  REAR_RIGHT_TIEROD: 'REAR_RIGHT_TIEROD',
  REAR_RIGHT_UCA_FWD: 'REAR_RIGHT_UCA_FWD',
  REAR_RIGHT_UCA_RWD: 'REAR_RIGHT_UCA_RWD',
  REAR_RIGHT_UPPER: 'REAR_RIGHT_UPPER',
  REAR_SECONDARY: 'REAR_SECONDARY',
  RIGHT: 'RIGHT',
  SECONDARY: 'SECONDARY',
  SINGLE: 'SINGLE',
  STEERING_COLUMN: 'STEERING_COLUMN',
  STEERING_RACK: 'STEERING_RACK',
  STEERING_SHAFT: 'STEERING_SHAFT'
} as const;

export type EnumPartReadingLocationOverride = typeof EnumPartReadingLocationOverride[keyof typeof EnumPartReadingLocationOverride];
export const EnumPersonCarUpdateMethod = {
  FORWARD_PROPAGATE: 'FORWARD_PROPAGATE',
  STANDARD: 'STANDARD'
} as const;

export type EnumPersonCarUpdateMethod = typeof EnumPersonCarUpdateMethod[keyof typeof EnumPersonCarUpdateMethod];
export const EnumPersonMileageUnit = {
  CENTIMETRES: 'CENTIMETRES',
  FEET: 'FEET',
  INCHES: 'INCHES',
  KILOMETRES: 'KILOMETRES',
  METRES: 'METRES',
  MICROMETRES: 'MICROMETRES',
  MILES: 'MILES',
  MILLIMETRES: 'MILLIMETRES',
  THOU: 'THOU'
} as const;

export type EnumPersonMileageUnit = typeof EnumPersonMileageUnit[keyof typeof EnumPersonMileageUnit];
export const EnumPersonRole = {
  ADMIN: 'ADMIN',
  CAR_ENGINEER: 'CAR_ENGINEER',
  CHIEF_ENGINEER: 'CHIEF_ENGINEER',
  DRIVER: 'DRIVER',
  FAULT_ADMIN: 'FAULT_ADMIN',
  MANAGEMENT: 'MANAGEMENT',
  MECHANIC: 'MECHANIC',
  READ_ONLY: 'READ_ONLY',
  SETUP_REVIEWER: 'SETUP_REVIEWER',
  TYRE_ENGINEER: 'TYRE_ENGINEER',
  WORKSHOP_MANAGEMENT: 'WORKSHOP_MANAGEMENT'
} as const;

export type EnumPersonRole = typeof EnumPersonRole[keyof typeof EnumPersonRole];
export const EnumPlotConfigXAxisType = {
  NUMBER: 'NUMBER',
  TIME: 'TIME'
} as const;

export type EnumPlotConfigXAxisType = typeof EnumPlotConfigXAxisType[keyof typeof EnumPlotConfigXAxisType];
export const EnumPossibleUnit = {
  BAR: 'BAR',
  CELSIUS: 'CELSIUS',
  CENTIMETRES: 'CENTIMETRES',
  DAYS: 'DAYS',
  DEGREES: 'DEGREES',
  DEGREES_PER_FOOT_POUND: 'DEGREES_PER_FOOT_POUND',
  DEGREES_PER_INCHES: 'DEGREES_PER_INCHES',
  DEGREES_PER_MILLIMETRES: 'DEGREES_PER_MILLIMETRES',
  DEGREES_PER_POUND: 'DEGREES_PER_POUND',
  DEGREES_PER_SECOND: 'DEGREES_PER_SECOND',
  DEGREES_PER_SECOND_SQUARED: 'DEGREES_PER_SECOND_SQUARED',
  FAHRENHEIT: 'FAHRENHEIT',
  FEET: 'FEET',
  FEET_PER_SECOND: 'FEET_PER_SECOND',
  FEET_PER_SECOND_SQUARED: 'FEET_PER_SECOND_SQUARED',
  GALLONS: 'GALLONS',
  GFORCE: 'GFORCE',
  GRAMS: 'GRAMS',
  HORSEPOWER_MECHANICAL: 'HORSEPOWER_MECHANICAL',
  HOURS: 'HOURS',
  INCHES: 'INCHES',
  INCHES_OF_MERCURY: 'INCHES_OF_MERCURY',
  INCHES_PER_POUND_FORCE: 'INCHES_PER_POUND_FORCE',
  JOULES: 'JOULES',
  KELVIN: 'KELVIN',
  KILOGRAMS: 'KILOGRAMS',
  KILOGRAM_METRES_SQUARED: 'KILOGRAM_METRES_SQUARED',
  KILOJOULES: 'KILOJOULES',
  KILOMETRES: 'KILOMETRES',
  KILOMETRES_PER_HOUR: 'KILOMETRES_PER_HOUR',
  KILOPASCALS: 'KILOPASCALS',
  KILOWATTS: 'KILOWATTS',
  KILOWATT_HOURS: 'KILOWATT_HOURS',
  LITRES: 'LITRES',
  METRES: 'METRES',
  METRES_CUBED: 'METRES_CUBED',
  METRES_PER_NEWTON: 'METRES_PER_NEWTON',
  METRES_PER_SECOND: 'METRES_PER_SECOND',
  METRES_PER_SECOND_SQUARED: 'METRES_PER_SECOND_SQUARED',
  MICROMETRES: 'MICROMETRES',
  MILES: 'MILES',
  MILES_PER_HOUR: 'MILES_PER_HOUR',
  MILLIBAR: 'MILLIBAR',
  MILLIGRAMS: 'MILLIGRAMS',
  MILLILITRES: 'MILLILITRES',
  MILLIMETRES: 'MILLIMETRES',
  MILLIMETRES_PER_NEWTON: 'MILLIMETRES_PER_NEWTON',
  MILLISECONDS: 'MILLISECONDS',
  MINUTES: 'MINUTES',
  NEWTONS: 'NEWTONS',
  NEWTONS_PER_METRE: 'NEWTONS_PER_METRE',
  NEWTONS_PER_MILLIMETRE: 'NEWTONS_PER_MILLIMETRE',
  NEWTON_METRES: 'NEWTON_METRES',
  NEWTON_METRES_PER_DEGREE: 'NEWTON_METRES_PER_DEGREE',
  NEWTON_METRES_PER_RADIAN: 'NEWTON_METRES_PER_RADIAN',
  NEWTON_MILLIMETRES: 'NEWTON_MILLIMETRES',
  NONE: 'NONE',
  NUMBER: 'NUMBER',
  OUNCES: 'OUNCES',
  PASCALS: 'PASCALS',
  PERCENT: 'PERCENT',
  POUNDS: 'POUNDS',
  POUNDS_FEET_PER_DEGREE: 'POUNDS_FEET_PER_DEGREE',
  POUNDS_FEET_PER_RADIAN: 'POUNDS_FEET_PER_RADIAN',
  POUNDS_FORCE: 'POUNDS_FORCE',
  POUNDS_INCHES_PER_DEGREE: 'POUNDS_INCHES_PER_DEGREE',
  POUNDS_INCHES_PER_RADIAN: 'POUNDS_INCHES_PER_RADIAN',
  POUNDS_PER_INCH: 'POUNDS_PER_INCH',
  POUND_FOOT_ENERGY: 'POUND_FOOT_ENERGY',
  POUND_FOOT_SECONDS_SQUARED: 'POUND_FOOT_SECONDS_SQUARED',
  POUND_FORCE_FEET: 'POUND_FORCE_FEET',
  POUND_FORCE_INCHES: 'POUND_FORCE_INCHES',
  PSI: 'PSI',
  RADIANS: 'RADIANS',
  RADIANS_PER_NEWTON: 'RADIANS_PER_NEWTON',
  RADIANS_PER_NEWTON_METRE: 'RADIANS_PER_NEWTON_METRE',
  RADIANS_PER_SECOND: 'RADIANS_PER_SECOND',
  RADIANS_PER_SECOND_SQUARED: 'RADIANS_PER_SECOND_SQUARED',
  RATIO: 'RATIO',
  SECONDS: 'SECONDS',
  STRING: 'STRING',
  THOU: 'THOU',
  WATTS: 'WATTS'
} as const;

export type EnumPossibleUnit = typeof EnumPossibleUnit[keyof typeof EnumPossibleUnit];
export const EnumPowerUnit = {
  HORSEPOWER_MECHANICAL: 'HORSEPOWER_MECHANICAL',
  KILOWATTS: 'KILOWATTS',
  WATTS: 'WATTS'
} as const;

export type EnumPowerUnit = typeof EnumPowerUnit[keyof typeof EnumPowerUnit];
export const EnumPowertrainLayout = {
  F4: 'F4',
  FF: 'FF',
  FR: 'FR',
  M4: 'M4',
  MR: 'MR',
  R4: 'R4',
  RR: 'RR'
} as const;

export type EnumPowertrainLayout = typeof EnumPowertrainLayout[keyof typeof EnumPowertrainLayout];
export const EnumPressureOption = {
  PARC_FERME_EXPECTED: 'PARC_FERME_EXPECTED',
  POST_RUN: 'POST_RUN',
  POST_RUN_BLEED: 'POST_RUN_BLEED',
  SET_DOWN: 'SET_DOWN'
} as const;

export type EnumPressureOption = typeof EnumPressureOption[keyof typeof EnumPressureOption];
export const EnumPressureUnit = {
  BAR: 'BAR',
  INCHES_OF_MERCURY: 'INCHES_OF_MERCURY',
  KILOPASCALS: 'KILOPASCALS',
  MILLIBAR: 'MILLIBAR',
  PASCALS: 'PASCALS',
  PSI: 'PSI'
} as const;

export type EnumPressureUnit = typeof EnumPressureUnit[keyof typeof EnumPressureUnit];
export const EnumQualityCheckActionPriority = {
  HIGH: 'HIGH',
  LOW: 'LOW',
  MAXIMUM: 'MAXIMUM',
  MEDIUM: 'MEDIUM',
  NONE: 'NONE',
  PRIO1_MAXIMUM: 'PRIO1_MAXIMUM',
  PRIO2_HIGH: 'PRIO2_HIGH',
  PRIO3_MEDIUM: 'PRIO3_MEDIUM',
  PRIO4_LOW: 'PRIO4_LOW',
  PRIO5_NONE: 'PRIO5_NONE'
} as const;

export type EnumQualityCheckActionPriority = typeof EnumQualityCheckActionPriority[keyof typeof EnumQualityCheckActionPriority];
export const EnumQualityCheckActionStatus = {
  COMPLETE: 'COMPLETE',
  ONGOING: 'ONGOING',
  TODO: 'TODO'
} as const;

export type EnumQualityCheckActionStatus = typeof EnumQualityCheckActionStatus[keyof typeof EnumQualityCheckActionStatus];
export const EnumRaceSeriesDriversPerCar = {
  multiple: 'multiple',
  single: 'single'
} as const;

export type EnumRaceSeriesDriversPerCar = typeof EnumRaceSeriesDriversPerCar[keyof typeof EnumRaceSeriesDriversPerCar];
export const EnumRatioUnit = {
  PERCENT: 'PERCENT',
  RATIO: 'RATIO'
} as const;

export type EnumRatioUnit = typeof EnumRatioUnit[keyof typeof EnumRatioUnit];
export const EnumReadingLocation = {
  CENTER: 'CENTER',
  ENGINE_IN: 'ENGINE_IN',
  ENGINE_OUT: 'ENGINE_OUT',
  FRONT: 'FRONT',
  FRONT_LEFT: 'FRONT_LEFT',
  FRONT_LEFT_FORWARD: 'FRONT_LEFT_FORWARD',
  FRONT_LEFT_INNER: 'FRONT_LEFT_INNER',
  FRONT_LEFT_LCA_FWD: 'FRONT_LEFT_LCA_FWD',
  FRONT_LEFT_LCA_RWD: 'FRONT_LEFT_LCA_RWD',
  FRONT_LEFT_LOWER: 'FRONT_LEFT_LOWER',
  FRONT_LEFT_OUTER: 'FRONT_LEFT_OUTER',
  FRONT_LEFT_PUSHROD: 'FRONT_LEFT_PUSHROD',
  FRONT_LEFT_REARWARD: 'FRONT_LEFT_REARWARD',
  FRONT_LEFT_TIEROD: 'FRONT_LEFT_TIEROD',
  FRONT_LEFT_UCA_FWD: 'FRONT_LEFT_UCA_FWD',
  FRONT_LEFT_UCA_RWD: 'FRONT_LEFT_UCA_RWD',
  FRONT_LEFT_UPPER: 'FRONT_LEFT_UPPER',
  FRONT_PRIMARY: 'FRONT_PRIMARY',
  FRONT_RIGHT: 'FRONT_RIGHT',
  FRONT_RIGHT_FORWARD: 'FRONT_RIGHT_FORWARD',
  FRONT_RIGHT_INNER: 'FRONT_RIGHT_INNER',
  FRONT_RIGHT_LCA_FWD: 'FRONT_RIGHT_LCA_FWD',
  FRONT_RIGHT_LCA_RWD: 'FRONT_RIGHT_LCA_RWD',
  FRONT_RIGHT_LOWER: 'FRONT_RIGHT_LOWER',
  FRONT_RIGHT_OUTER: 'FRONT_RIGHT_OUTER',
  FRONT_RIGHT_PUSHROD: 'FRONT_RIGHT_PUSHROD',
  FRONT_RIGHT_REARWARD: 'FRONT_RIGHT_REARWARD',
  FRONT_RIGHT_TIEROD: 'FRONT_RIGHT_TIEROD',
  FRONT_RIGHT_UCA_FWD: 'FRONT_RIGHT_UCA_FWD',
  FRONT_RIGHT_UCA_RWD: 'FRONT_RIGHT_UCA_RWD',
  FRONT_RIGHT_UPPER: 'FRONT_RIGHT_UPPER',
  FRONT_SECONDARY: 'FRONT_SECONDARY',
  GBX_IN: 'GBX_IN',
  GBX_OUT: 'GBX_OUT',
  INPUT: 'INPUT',
  LEFT: 'LEFT',
  MGU_IN: 'MGU_IN',
  MGU_OUT: 'MGU_OUT',
  OUTPUT: 'OUTPUT',
  PRIMARY: 'PRIMARY',
  REAR: 'REAR',
  REAR_LEFT: 'REAR_LEFT',
  REAR_LEFT_FORWARD: 'REAR_LEFT_FORWARD',
  REAR_LEFT_INNER: 'REAR_LEFT_INNER',
  REAR_LEFT_LCA_FWD: 'REAR_LEFT_LCA_FWD',
  REAR_LEFT_LCA_RWD: 'REAR_LEFT_LCA_RWD',
  REAR_LEFT_LOWER: 'REAR_LEFT_LOWER',
  REAR_LEFT_OUTER: 'REAR_LEFT_OUTER',
  REAR_LEFT_PUSHROD: 'REAR_LEFT_PUSHROD',
  REAR_LEFT_REARWARD: 'REAR_LEFT_REARWARD',
  REAR_LEFT_TIEROD: 'REAR_LEFT_TIEROD',
  REAR_LEFT_UCA_FWD: 'REAR_LEFT_UCA_FWD',
  REAR_LEFT_UCA_RWD: 'REAR_LEFT_UCA_RWD',
  REAR_LEFT_UPPER: 'REAR_LEFT_UPPER',
  REAR_PRIMARY: 'REAR_PRIMARY',
  REAR_RIGHT: 'REAR_RIGHT',
  REAR_RIGHT_FORWARD: 'REAR_RIGHT_FORWARD',
  REAR_RIGHT_INNER: 'REAR_RIGHT_INNER',
  REAR_RIGHT_LCA_FWD: 'REAR_RIGHT_LCA_FWD',
  REAR_RIGHT_LCA_RWD: 'REAR_RIGHT_LCA_RWD',
  REAR_RIGHT_LOWER: 'REAR_RIGHT_LOWER',
  REAR_RIGHT_OUTER: 'REAR_RIGHT_OUTER',
  REAR_RIGHT_PUSHROD: 'REAR_RIGHT_PUSHROD',
  REAR_RIGHT_REARWARD: 'REAR_RIGHT_REARWARD',
  REAR_RIGHT_TIEROD: 'REAR_RIGHT_TIEROD',
  REAR_RIGHT_UCA_FWD: 'REAR_RIGHT_UCA_FWD',
  REAR_RIGHT_UCA_RWD: 'REAR_RIGHT_UCA_RWD',
  REAR_RIGHT_UPPER: 'REAR_RIGHT_UPPER',
  REAR_SECONDARY: 'REAR_SECONDARY',
  RIGHT: 'RIGHT',
  SECONDARY: 'SECONDARY',
  SINGLE: 'SINGLE',
  STEERING_COLUMN: 'STEERING_COLUMN',
  STEERING_RACK: 'STEERING_RACK',
  STEERING_SHAFT: 'STEERING_SHAFT'
} as const;

export type EnumReadingLocation = typeof EnumReadingLocation[keyof typeof EnumReadingLocation];
export const EnumReportNotePageAppendixNotesMode = {
  markdown: 'markdown',
  table: 'table'
} as const;

export type EnumReportNotePageAppendixNotesMode = typeof EnumReportNotePageAppendixNotesMode[keyof typeof EnumReportNotePageAppendixNotesMode];
export const EnumReportNotePageOverviewNotesMode = {
  markdown: 'markdown',
  table: 'table'
} as const;

export type EnumReportNotePageOverviewNotesMode = typeof EnumReportNotePageOverviewNotesMode[keyof typeof EnumReportNotePageOverviewNotesMode];
export const EnumReportNotePagePartsNotesMode = {
  markdown: 'markdown',
  table: 'table'
} as const;

export type EnumReportNotePagePartsNotesMode = typeof EnumReportNotePagePartsNotesMode[keyof typeof EnumReportNotePagePartsNotesMode];
export const EnumReportNotePageRunPlanNotesMode = {
  markdown: 'markdown',
  table: 'table'
} as const;

export type EnumReportNotePageRunPlanNotesMode = typeof EnumReportNotePageRunPlanNotesMode[keyof typeof EnumReportNotePageRunPlanNotesMode];
export const EnumReportNotePageSessionNotesMode = {
  markdown: 'markdown',
  table: 'table'
} as const;

export type EnumReportNotePageSessionNotesMode = typeof EnumReportNotePageSessionNotesMode[keyof typeof EnumReportNotePageSessionNotesMode];
export const EnumReportNotesTemplatePageAppendixNotesMode = {
  markdown: 'markdown',
  table: 'table'
} as const;

export type EnumReportNotesTemplatePageAppendixNotesMode = typeof EnumReportNotesTemplatePageAppendixNotesMode[keyof typeof EnumReportNotesTemplatePageAppendixNotesMode];
export const EnumReportNotesTemplatePageOverviewNotesMode = {
  markdown: 'markdown',
  table: 'table'
} as const;

export type EnumReportNotesTemplatePageOverviewNotesMode = typeof EnumReportNotesTemplatePageOverviewNotesMode[keyof typeof EnumReportNotesTemplatePageOverviewNotesMode];
export const EnumReportNotesTemplatePagePartsNotesMode = {
  markdown: 'markdown',
  table: 'table'
} as const;

export type EnumReportNotesTemplatePagePartsNotesMode = typeof EnumReportNotesTemplatePagePartsNotesMode[keyof typeof EnumReportNotesTemplatePagePartsNotesMode];
export const EnumReportNotesTemplatePageRunPlanNotesMode = {
  markdown: 'markdown',
  table: 'table'
} as const;

export type EnumReportNotesTemplatePageRunPlanNotesMode = typeof EnumReportNotesTemplatePageRunPlanNotesMode[keyof typeof EnumReportNotesTemplatePageRunPlanNotesMode];
export const EnumReportNotesTemplatePageSessionNotesMode = {
  markdown: 'markdown',
  table: 'table'
} as const;

export type EnumReportNotesTemplatePageSessionNotesMode = typeof EnumReportNotesTemplatePageSessionNotesMode[keyof typeof EnumReportNotesTemplatePageSessionNotesMode];
export const EnumReportPage = {
  pageAppendix: 'pageAppendix',
  pageOverview: 'pageOverview',
  pageParts: 'pageParts',
  pageRunPlan: 'pageRunPlan',
  pageSession: 'pageSession'
} as const;

export type EnumReportPage = typeof EnumReportPage[keyof typeof EnumReportPage];
export const EnumReportTemplateIssuesColumnsField = {
  area: 'area',
  assignees: 'assignees',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  department: 'department',
  description: 'description',
  descriptionDetails: 'descriptionDetails',
  issueStatus: 'issueStatus',
  number: 'number',
  priority: 'priority',
  tags: 'tags',
  teams: 'teams',
  updatedAt: 'updatedAt'
} as const;

export type EnumReportTemplateIssuesColumnsField = typeof EnumReportTemplateIssuesColumnsField[keyof typeof EnumReportTemplateIssuesColumnsField];
export const EnumReportTemplateIssuesGroupBy = {
  area: 'area',
  cat: 'cat',
  createdBy: 'createdBy',
  customer: 'customer',
  department: 'department',
  responsible: 'responsible',
  status: 'status',
  tags: 'tags'
} as const;

export type EnumReportTemplateIssuesGroupBy = typeof EnumReportTemplateIssuesGroupBy[keyof typeof EnumReportTemplateIssuesGroupBy];
export const EnumReportTemplateRunInfoColumnsField = {
  NRunData: 'NRunData',
  NRunTiming: 'NRunTiming',
  TAmbient: 'TAmbient',
  TTrack: 'TTrack',
  brakeComment: 'brakeComment',
  controlsComment: 'controlsComment',
  dilComments: 'dilComments',
  driverAcronym: 'driverAcronym',
  driverComments: 'driverComments',
  endTime: 'endTime',
  engineerComments: 'engineerComments',
  fastestLap: 'fastestLap',
  info: 'info',
  lapcount: 'lapcount',
  mFuelRunStart: 'mFuelRunStart',
  mileage: 'mileage',
  problemComments: 'problemComments',
  runDescription: 'runDescription',
  skidComment: 'skidComment',
  startNumber: 'startNumber',
  startTime: 'startTime',
  systemsComments: 'systemsComments',
  tyreComments: 'tyreComments',
  tyreSetName: 'tyreSetName'
} as const;

export type EnumReportTemplateRunInfoColumnsField = typeof EnumReportTemplateRunInfoColumnsField[keyof typeof EnumReportTemplateRunInfoColumnsField];
export const EnumRunEnergyField = {
  ATTACK: 'ATTACK',
  COOL: 'COOL',
  FCY: 'FCY',
  IN: 'IN',
  OUT: 'OUT',
  OUTIN: 'OUTIN',
  PITLANE: 'PITLANE',
  PREP: 'PREP',
  PUSH: 'PUSH',
  QUALI: 'QUALI',
  SAFETYCAR: 'SAFETYCAR',
  SHAKEDOWN: 'SHAKEDOWN',
  SLOW: 'SLOW',
  TARGET: 'TARGET',
  TOGRID: 'TOGRID',
  TOPADDOCK: 'TOPADDOCK',
  TOPITS: 'TOPITS',
  UNFINISHED: 'UNFINISHED'
} as const;

export type EnumRunEnergyField = typeof EnumRunEnergyField[keyof typeof EnumRunEnergyField];
export const EnumRunPlanRunPriority = {
  PRIO1_MAXIMUM: 'PRIO1_MAXIMUM',
  PRIO2_HIGH: 'PRIO2_HIGH',
  PRIO3_MEDIUM: 'PRIO3_MEDIUM',
  PRIO4_LOW: 'PRIO4_LOW',
  PRIO5_NONE: 'PRIO5_NONE'
} as const;

export type EnumRunPlanRunPriority = typeof EnumRunPlanRunPriority[keyof typeof EnumRunPlanRunPriority];
export const EnumRunSheetKpiStatus = {
  AUGMENTATION: 'AUGMENTATION',
  DATA: 'DATA',
  VTAG: 'VTAG'
} as const;

export type EnumRunSheetKpiStatus = typeof EnumRunSheetKpiStatus[keyof typeof EnumRunSheetKpiStatus];
export const EnumRunSheetStyleBlockStyle = {
  F2: 'F2',
  FE: 'FE',
  GT: 'GT',
  LMP2: 'LMP2',
  WSERIES: 'WSERIES'
} as const;

export type EnumRunSheetStyleBlockStyle = typeof EnumRunSheetStyleBlockStyle[keyof typeof EnumRunSheetStyleBlockStyle];
export const EnumServerSettingsSimulationColoringMethod = {
  INHERIT_FROM_RUN: 'INHERIT_FROM_RUN',
  OWN_PALETTE: 'OWN_PALETTE'
} as const;

export type EnumServerSettingsSimulationColoringMethod = typeof EnumServerSettingsSimulationColoringMethod[keyof typeof EnumServerSettingsSimulationColoringMethod];
export const EnumSessionDebriefNotesMode = {
  markdown: 'markdown',
  table: 'table'
} as const;

export type EnumSessionDebriefNotesMode = typeof EnumSessionDebriefNotesMode[keyof typeof EnumSessionDebriefNotesMode];
export const EnumSessionType = {
  DiL: 'DiL',
  EventSchedule: 'EventSchedule',
  ExternalMeeting: 'ExternalMeeting',
  FreePractice: 'FreePractice',
  Info: 'Info',
  InternalMeeting: 'InternalMeeting',
  ParcFerme: 'ParcFerme',
  Qualifying: 'Qualifying',
  Race: 'Race',
  SessionNotification: 'SessionNotification',
  Setup: 'Setup',
  Simulation: 'Simulation',
  Team: 'Team',
  Test: 'Test',
  VirtualMeeting: 'VirtualMeeting'
} as const;

export type EnumSessionType = typeof EnumSessionType[keyof typeof EnumSessionType];
export const EnumSetupSheetStyleItemType = {
  CHECKBOX: 'CHECKBOX',
  INPUT: 'INPUT',
  LABEL: 'LABEL',
  READONLY_FIELD: 'READONLY_FIELD',
  SELECT: 'SELECT',
  SPACER: 'SPACER'
} as const;

export type EnumSetupSheetStyleItemType = typeof EnumSetupSheetStyleItemType[keyof typeof EnumSetupSheetStyleItemType];
export const EnumSetupSheetStyleTabType = {
  CHASSIS_MEASUREMENT: 'CHASSIS_MEASUREMENT',
  CUSTOM: 'CUSTOM',
  MASS: 'MASS',
  MILEAGE: 'MILEAGE',
  XE_CALCULATIONS: 'XE_CALCULATIONS'
} as const;

export type EnumSetupSheetStyleTabType = typeof EnumSetupSheetStyleTabType[keyof typeof EnumSetupSheetStyleTabType];
export const EnumSetupSheetStyleTargetEventType = {
  AEROTEST: 'AEROTEST',
  ANY: 'ANY',
  OVAL: 'OVAL',
  ROADCOURSE: 'ROADCOURSE'
} as const;

export type EnumSetupSheetStyleTargetEventType = typeof EnumSetupSheetStyleTargetEventType[keyof typeof EnumSetupSheetStyleTargetEventType];
export const EnumSetupSheetStyleType = {
  FULL: 'FULL',
  MINI: 'MINI',
  SIMULATION: 'SIMULATION'
} as const;

export type EnumSetupSheetStyleType = typeof EnumSetupSheetStyleType[keyof typeof EnumSetupSheetStyleType];
export const EnumSimModelType = {
  CANOPY: 'CANOPY',
  CHASSIS_SIM: 'CHASSIS_SIM',
  CUSTOM: 'CUSTOM'
} as const;

export type EnumSimModelType = typeof EnumSimModelType[keyof typeof EnumSimModelType];
export const EnumSimRequestRequesterSlot = {
  RUN01_06: 'RUN01_06',
  SETUP01_02: 'SETUP01_02'
} as const;

export type EnumSimRequestRequesterSlot = typeof EnumSimRequestRequesterSlot[keyof typeof EnumSimRequestRequesterSlot];
export const EnumSimRequestSimType = {
  CAR_MODEL_POST: 'CAR_MODEL_POST',
  DATA_REPLAY: 'DATA_REPLAY',
  DEVELOPMENT: 'DEVELOPMENT',
  DYNAMIC_LAP: 'DYNAMIC_LAP',
  EIGHT_POST: 'EIGHT_POST',
  KINEMATICS: 'KINEMATICS',
  KNC: 'KNC',
  MODEL_REQUEST: 'MODEL_REQUEST',
  QUASI_STATIC_LAP: 'QUASI_STATIC_LAP',
  SETUP: 'SETUP',
  STEADY_STATE_LATERAL: 'STEADY_STATE_LATERAL',
  STEADY_STATE_STRAIGHT_LINE: 'STEADY_STATE_STRAIGHT_LINE'
} as const;

export type EnumSimRequestSimType = typeof EnumSimRequestSimType[keyof typeof EnumSimRequestSimType];
export const EnumSimResultDataInterpolationMethod = {
  HOLD_PREVIOUS: 'HOLD_PREVIOUS',
  LINEAR: 'LINEAR',
  NEAREST: 'NEAREST',
  NONE: 'NONE'
} as const;

export type EnumSimResultDataInterpolationMethod = typeof EnumSimResultDataInterpolationMethod[keyof typeof EnumSimResultDataInterpolationMethod];
export const EnumSimResultSimType = {
  CAR_MODEL_POST: 'CAR_MODEL_POST',
  DATA_REPLAY: 'DATA_REPLAY',
  DEVELOPMENT: 'DEVELOPMENT',
  DYNAMIC_LAP: 'DYNAMIC_LAP',
  EIGHT_POST: 'EIGHT_POST',
  KINEMATICS: 'KINEMATICS',
  KNC: 'KNC',
  MODEL_REQUEST: 'MODEL_REQUEST',
  QUASI_STATIC_LAP: 'QUASI_STATIC_LAP',
  SETUP: 'SETUP',
  STEADY_STATE_LATERAL: 'STEADY_STATE_LATERAL',
  STEADY_STATE_STRAIGHT_LINE: 'STEADY_STATE_STRAIGHT_LINE'
} as const;

export type EnumSimResultSimType = typeof EnumSimResultSimType[keyof typeof EnumSimResultSimType];
export const EnumSimResultStatus = {
  COMPLETE: 'COMPLETE',
  DRAFT: 'DRAFT',
  FAILED: 'FAILED',
  QUEUED: 'QUEUED',
  RUNNING: 'RUNNING'
} as const;

export type EnumSimResultStatus = typeof EnumSimResultStatus[keyof typeof EnumSimResultStatus];
export const EnumSimulationDriveFileStatus = {
  ARCHIVED: 'ARCHIVED',
  DRAFT: 'DRAFT',
  RELEASED: 'RELEASED'
} as const;

export type EnumSimulationDriveFileStatus = typeof EnumSimulationDriveFileStatus[keyof typeof EnumSimulationDriveFileStatus];
export const EnumSpecificationACamberReadingsRequired = {
  CONTROL_ARM: 'CONTROL_ARM',
  CORNERS: 'CORNERS',
  CORNER_FORWARD_REARWARD: 'CORNER_FORWARD_REARWARD',
  CORNER_INNER_OUTER: 'CORNER_INNER_OUTER',
  CORNER_LOWER_UPPER: 'CORNER_LOWER_UPPER',
  FRONT_REAR: 'FRONT_REAR',
  FRONT_REAR_PRIMARY_SECONDARY: 'FRONT_REAR_PRIMARY_SECONDARY',
  INPUT_CENTER_OUTPUT: 'INPUT_CENTER_OUTPUT',
  LEFT_RIGHT: 'LEFT_RIGHT',
  POWERTRAIN: 'POWERTRAIN',
  PRIMARY_SECONDARY: 'PRIMARY_SECONDARY',
  SINGLE: 'SINGLE',
  SUSPENSION_MEMBER: 'SUSPENSION_MEMBER'
} as const;

export type EnumSpecificationACamberReadingsRequired = typeof EnumSpecificationACamberReadingsRequired[keyof typeof EnumSpecificationACamberReadingsRequired];
export const EnumSpecificationACamberUnit = {
  DEGREES: 'DEGREES',
  MINUTES: 'MINUTES',
  RADIANS: 'RADIANS'
} as const;

export type EnumSpecificationACamberUnit = typeof EnumSpecificationACamberUnit[keyof typeof EnumSpecificationACamberUnit];
export const EnumSpecificationAdminAeroElementInterpolationMethod = {
  AFLAP: 'AFLAP',
  CLOSEST: 'CLOSEST',
  LINEAR: 'LINEAR',
  NONE: 'NONE',
  POLYNOMIAL: 'POLYNOMIAL',
  SPLINE: 'SPLINE'
} as const;

export type EnumSpecificationAdminAeroElementInterpolationMethod = typeof EnumSpecificationAdminAeroElementInterpolationMethod[keyof typeof EnumSpecificationAdminAeroElementInterpolationMethod];
export const EnumSpecificationAdminAeroElementType = {
  INTERPOLATE: 'INTERPOLATE',
  POLYNOMIAL: 'POLYNOMIAL',
  STRICT: 'STRICT'
} as const;

export type EnumSpecificationAdminAeroElementType = typeof EnumSpecificationAdminAeroElementType[keyof typeof EnumSpecificationAdminAeroElementType];
export const EnumSpecificationAdminAntiRollBarDisplayLocation = {
  FRONT: 'FRONT',
  REAR: 'REAR'
} as const;

export type EnumSpecificationAdminAntiRollBarDisplayLocation = typeof EnumSpecificationAdminAntiRollBarDisplayLocation[keyof typeof EnumSpecificationAdminAntiRollBarDisplayLocation];
export const EnumSpecificationAdminAxle = {
  FRONT: 'FRONT',
  REAR: 'REAR'
} as const;

export type EnumSpecificationAdminAxle = typeof EnumSpecificationAdminAxle[keyof typeof EnumSpecificationAdminAxle];
export const EnumSpecificationAdminBumpRubberReference = {
  DROOP: 'DROOP',
  FORCE: 'FORCE',
  REF: 'REF',
  STATIC: 'STATIC'
} as const;

export type EnumSpecificationAdminBumpRubberReference = typeof EnumSpecificationAdminBumpRubberReference[keyof typeof EnumSpecificationAdminBumpRubberReference];
export const EnumSpecificationAdminBumpStopGapMethod = {
  GAP_TO_BASE: 'GAP_TO_BASE',
  GAP_TO_TOP: 'GAP_TO_TOP',
  PACKER_STACK: 'PACKER_STACK'
} as const;

export type EnumSpecificationAdminBumpStopGapMethod = typeof EnumSpecificationAdminBumpStopGapMethod[keyof typeof EnumSpecificationAdminBumpStopGapMethod];
export const EnumSpecificationAdminElasticType = {
  BUMP_RUBBER: 'BUMP_RUBBER',
  HELPER_SPRING: 'HELPER_SPRING',
  REBOUND_SPRING: 'REBOUND_SPRING',
  SPRING: 'SPRING',
  TORSION_BAR: 'TORSION_BAR'
} as const;

export type EnumSpecificationAdminElasticType = typeof EnumSpecificationAdminElasticType[keyof typeof EnumSpecificationAdminElasticType];
export const EnumSpecificationAdminGearType = {
  BEVEL_SET: 'BEVEL_SET',
  DROP_GEAR: 'DROP_GEAR',
  STANDARD: 'STANDARD'
} as const;

export type EnumSpecificationAdminGearType = typeof EnumSpecificationAdminGearType[keyof typeof EnumSpecificationAdminGearType];
export const EnumSpecificationAdminModelTypes = {
  CANOPY: 'CANOPY',
  CHASSIS_SIM: 'CHASSIS_SIM',
  CUSTOM: 'CUSTOM'
} as const;

export type EnumSpecificationAdminModelTypes = typeof EnumSpecificationAdminModelTypes[keyof typeof EnumSpecificationAdminModelTypes];
export const EnumSpecificationAdminPowertrainLocation = {
  CENTRAL: 'CENTRAL',
  FRONT: 'FRONT',
  REAR: 'REAR'
} as const;

export type EnumSpecificationAdminPowertrainLocation = typeof EnumSpecificationAdminPowertrainLocation[keyof typeof EnumSpecificationAdminPowertrainLocation];
export const EnumSpecificationAdminReadingsAllowable = {
  FRONT: 'FRONT',
  FRONT_LEFT: 'FRONT_LEFT',
  FRONT_LEFT_LCA_FWD: 'FRONT_LEFT_LCA_FWD',
  FRONT_LEFT_LCA_RWD: 'FRONT_LEFT_LCA_RWD',
  FRONT_LEFT_UCA_FWD: 'FRONT_LEFT_UCA_FWD',
  FRONT_LEFT_UCA_RWD: 'FRONT_LEFT_UCA_RWD',
  FRONT_RIGHT: 'FRONT_RIGHT',
  FRONT_RIGHT_LCA_FWD: 'FRONT_RIGHT_LCA_FWD',
  FRONT_RIGHT_LCA_RWD: 'FRONT_RIGHT_LCA_RWD',
  FRONT_RIGHT_UCA_FWD: 'FRONT_RIGHT_UCA_FWD',
  FRONT_RIGHT_UCA_RWD: 'FRONT_RIGHT_UCA_RWD',
  LEFT: 'LEFT',
  REAR: 'REAR',
  REAR_LEFT: 'REAR_LEFT',
  REAR_LEFT_LCA_FWD: 'REAR_LEFT_LCA_FWD',
  REAR_LEFT_LCA_RWD: 'REAR_LEFT_LCA_RWD',
  REAR_LEFT_UCA_FWD: 'REAR_LEFT_UCA_FWD',
  REAR_LEFT_UCA_RWD: 'REAR_LEFT_UCA_RWD',
  REAR_RIGHT: 'REAR_RIGHT',
  REAR_RIGHT_LCA_FWD: 'REAR_RIGHT_LCA_FWD',
  REAR_RIGHT_LCA_RWD: 'REAR_RIGHT_LCA_RWD',
  REAR_RIGHT_UCA_FWD: 'REAR_RIGHT_UCA_FWD',
  REAR_RIGHT_UCA_RWD: 'REAR_RIGHT_UCA_RWD',
  RIGHT: 'RIGHT',
  SINGLE: 'SINGLE'
} as const;

export type EnumSpecificationAdminReadingsAllowable = typeof EnumSpecificationAdminReadingsAllowable[keyof typeof EnumSpecificationAdminReadingsAllowable];
export const EnumSpecificationAdminReadingsRequired = {
  CONTROL_ARM: 'CONTROL_ARM',
  CORNERS: 'CORNERS',
  CORNER_FORWARD_REARWARD: 'CORNER_FORWARD_REARWARD',
  CORNER_INNER_OUTER: 'CORNER_INNER_OUTER',
  CORNER_LOWER_UPPER: 'CORNER_LOWER_UPPER',
  FRONT_REAR: 'FRONT_REAR',
  FRONT_REAR_PRIMARY_SECONDARY: 'FRONT_REAR_PRIMARY_SECONDARY',
  INPUT_CENTER_OUTPUT: 'INPUT_CENTER_OUTPUT',
  LEFT_RIGHT: 'LEFT_RIGHT',
  POWERTRAIN: 'POWERTRAIN',
  PRIMARY_SECONDARY: 'PRIMARY_SECONDARY',
  SINGLE: 'SINGLE',
  SUSPENSION_MEMBER: 'SUSPENSION_MEMBER'
} as const;

export type EnumSpecificationAdminReadingsRequired = typeof EnumSpecificationAdminReadingsRequired[keyof typeof EnumSpecificationAdminReadingsRequired];
export const EnumSpecificationAdminSpringReference = {
  DROOP: 'DROOP',
  FORCE: 'FORCE',
  REF: 'REF',
  STATIC: 'STATIC'
} as const;

export type EnumSpecificationAdminSpringReference = typeof EnumSpecificationAdminSpringReference[keyof typeof EnumSpecificationAdminSpringReference];
export const EnumSpecificationAdminType = {
  AERO_ELEMENT: 'AERO_ELEMENT',
  AERO_PACKAGE: 'AERO_PACKAGE',
  ANTI_ROLL_BAR: 'ANTI_ROLL_BAR',
  CHASSIS: 'CHASSIS',
  CUSTOM: 'CUSTOM',
  DAMPER: 'DAMPER',
  DIFFERENTIAL: 'DIFFERENTIAL',
  ELASTIC: 'ELASTIC',
  GEAR: 'GEAR',
  GEAR_BOX: 'GEAR_BOX',
  KINEMATICS_EXTERNAL: 'KINEMATICS_EXTERNAL',
  KINEMATICS_INTERNAL: 'KINEMATICS_INTERNAL'
} as const;

export type EnumSpecificationAdminType = typeof EnumSpecificationAdminType[keyof typeof EnumSpecificationAdminType];
export const EnumSpecificationCustomSimulationModelsDataMapping = {
  Flat: 'Flat',
  Standard: 'Standard'
} as const;

export type EnumSpecificationCustomSimulationModelsDataMapping = typeof EnumSpecificationCustomSimulationModelsDataMapping[keyof typeof EnumSpecificationCustomSimulationModelsDataMapping];
export const EnumSpecificationHRideReadingsRequired = {
  CONTROL_ARM: 'CONTROL_ARM',
  CORNERS: 'CORNERS',
  CORNER_FORWARD_REARWARD: 'CORNER_FORWARD_REARWARD',
  CORNER_INNER_OUTER: 'CORNER_INNER_OUTER',
  CORNER_LOWER_UPPER: 'CORNER_LOWER_UPPER',
  FRONT_REAR: 'FRONT_REAR',
  FRONT_REAR_PRIMARY_SECONDARY: 'FRONT_REAR_PRIMARY_SECONDARY',
  INPUT_CENTER_OUTPUT: 'INPUT_CENTER_OUTPUT',
  LEFT_RIGHT: 'LEFT_RIGHT',
  POWERTRAIN: 'POWERTRAIN',
  PRIMARY_SECONDARY: 'PRIMARY_SECONDARY',
  SINGLE: 'SINGLE',
  SUSPENSION_MEMBER: 'SUSPENSION_MEMBER'
} as const;

export type EnumSpecificationHRideReadingsRequired = typeof EnumSpecificationHRideReadingsRequired[keyof typeof EnumSpecificationHRideReadingsRequired];
export const EnumSpecificationHRideUnit = {
  CENTIMETRES: 'CENTIMETRES',
  FEET: 'FEET',
  INCHES: 'INCHES',
  KILOMETRES: 'KILOMETRES',
  METRES: 'METRES',
  MICROMETRES: 'MICROMETRES',
  MILES: 'MILES',
  MILLIMETRES: 'MILLIMETRES',
  THOU: 'THOU'
} as const;

export type EnumSpecificationHRideUnit = typeof EnumSpecificationHRideUnit[keyof typeof EnumSpecificationHRideUnit];
export const EnumSpecificationPowertrainLocation = {
  CENTRAL: 'CENTRAL',
  FRONT: 'FRONT',
  REAR: 'REAR'
} as const;

export type EnumSpecificationPowertrainLocation = typeof EnumSpecificationPowertrainLocation[keyof typeof EnumSpecificationPowertrainLocation];
export const EnumSpecificationReadingsAllowable = {
  FRONT: 'FRONT',
  FRONT_LEFT: 'FRONT_LEFT',
  FRONT_LEFT_LCA_FWD: 'FRONT_LEFT_LCA_FWD',
  FRONT_LEFT_LCA_RWD: 'FRONT_LEFT_LCA_RWD',
  FRONT_LEFT_UCA_FWD: 'FRONT_LEFT_UCA_FWD',
  FRONT_LEFT_UCA_RWD: 'FRONT_LEFT_UCA_RWD',
  FRONT_RIGHT: 'FRONT_RIGHT',
  FRONT_RIGHT_LCA_FWD: 'FRONT_RIGHT_LCA_FWD',
  FRONT_RIGHT_LCA_RWD: 'FRONT_RIGHT_LCA_RWD',
  FRONT_RIGHT_UCA_FWD: 'FRONT_RIGHT_UCA_FWD',
  FRONT_RIGHT_UCA_RWD: 'FRONT_RIGHT_UCA_RWD',
  LEFT: 'LEFT',
  REAR: 'REAR',
  REAR_LEFT: 'REAR_LEFT',
  REAR_LEFT_LCA_FWD: 'REAR_LEFT_LCA_FWD',
  REAR_LEFT_LCA_RWD: 'REAR_LEFT_LCA_RWD',
  REAR_LEFT_UCA_FWD: 'REAR_LEFT_UCA_FWD',
  REAR_LEFT_UCA_RWD: 'REAR_LEFT_UCA_RWD',
  REAR_RIGHT: 'REAR_RIGHT',
  REAR_RIGHT_LCA_FWD: 'REAR_RIGHT_LCA_FWD',
  REAR_RIGHT_LCA_RWD: 'REAR_RIGHT_LCA_RWD',
  REAR_RIGHT_UCA_FWD: 'REAR_RIGHT_UCA_FWD',
  REAR_RIGHT_UCA_RWD: 'REAR_RIGHT_UCA_RWD',
  RIGHT: 'RIGHT',
  SINGLE: 'SINGLE'
} as const;

export type EnumSpecificationReadingsAllowable = typeof EnumSpecificationReadingsAllowable[keyof typeof EnumSpecificationReadingsAllowable];
export const EnumSpecificationReadingsRequired = {
  CONTROL_ARM: 'CONTROL_ARM',
  CORNERS: 'CORNERS',
  CORNER_FORWARD_REARWARD: 'CORNER_FORWARD_REARWARD',
  CORNER_INNER_OUTER: 'CORNER_INNER_OUTER',
  CORNER_LOWER_UPPER: 'CORNER_LOWER_UPPER',
  FRONT_REAR: 'FRONT_REAR',
  FRONT_REAR_PRIMARY_SECONDARY: 'FRONT_REAR_PRIMARY_SECONDARY',
  INPUT_CENTER_OUTPUT: 'INPUT_CENTER_OUTPUT',
  LEFT_RIGHT: 'LEFT_RIGHT',
  POWERTRAIN: 'POWERTRAIN',
  PRIMARY_SECONDARY: 'PRIMARY_SECONDARY',
  SINGLE: 'SINGLE',
  SUSPENSION_MEMBER: 'SUSPENSION_MEMBER'
} as const;

export type EnumSpecificationReadingsRequired = typeof EnumSpecificationReadingsRequired[keyof typeof EnumSpecificationReadingsRequired];
export const EnumSpecificationType = {
  AERO_ELEMENT: 'AERO_ELEMENT',
  AERO_PACKAGE: 'AERO_PACKAGE',
  ANTI_ROLL_BAR: 'ANTI_ROLL_BAR',
  CHASSIS: 'CHASSIS',
  CUSTOM: 'CUSTOM',
  DAMPER: 'DAMPER',
  DIFFERENTIAL: 'DIFFERENTIAL',
  ELASTIC: 'ELASTIC',
  GEAR: 'GEAR',
  GEAR_BOX: 'GEAR_BOX',
  KINEMATICS_EXTERNAL: 'KINEMATICS_EXTERNAL',
  KINEMATICS_INTERNAL: 'KINEMATICS_INTERNAL'
} as const;

export type EnumSpecificationType = typeof EnumSpecificationType[keyof typeof EnumSpecificationType];
export const EnumSpringRateUnit = {
  NEWTONS_PER_METRE: 'NEWTONS_PER_METRE',
  NEWTONS_PER_MILLIMETRE: 'NEWTONS_PER_MILLIMETRE',
  POUNDS_PER_INCH: 'POUNDS_PER_INCH'
} as const;

export type EnumSpringRateUnit = typeof EnumSpringRateUnit[keyof typeof EnumSpringRateUnit];
export const EnumSteeringRackRatioUnit = {
  DEGREES_PER_INCHES: 'DEGREES_PER_INCHES',
  DEGREES_PER_MILLIMETRES: 'DEGREES_PER_MILLIMETRES'
} as const;

export type EnumSteeringRackRatioUnit = typeof EnumSteeringRackRatioUnit[keyof typeof EnumSteeringRackRatioUnit];
export const EnumTagType = {
  ASSEMBLY: 'ASSEMBLY',
  CALCULATION: 'CALCULATION',
  CAR_SETUP: 'CAR_SETUP',
  CHASSIS: 'CHASSIS',
  GLOBAL: 'GLOBAL',
  ISSUE: 'ISSUE',
  JOB: 'JOB',
  LAP: 'LAP',
  PART: 'PART',
  PROJECT: 'PROJECT',
  RUN_SHEET: 'RUN_SHEET',
  SIM_RESULT: 'SIM_RESULT',
  TRACK: 'TRACK'
} as const;

export type EnumTagType = typeof EnumTagType[keyof typeof EnumTagType];
export const EnumTemperatureOption = {
  PARC_FERME_EXPECTED: 'PARC_FERME_EXPECTED',
  POST_RUN: 'POST_RUN',
  POST_RUN_BLEED: 'POST_RUN_BLEED',
  SET_DOWN: 'SET_DOWN'
} as const;

export type EnumTemperatureOption = typeof EnumTemperatureOption[keyof typeof EnumTemperatureOption];
export const EnumTemperatureUnit = {
  CELSIUS: 'CELSIUS',
  FAHRENHEIT: 'FAHRENHEIT',
  KELVIN: 'KELVIN'
} as const;

export type EnumTemperatureUnit = typeof EnumTemperatureUnit[keyof typeof EnumTemperatureUnit];
export const EnumTemplateSessionDebriefMode = {
  markdown: 'markdown',
  table: 'table'
} as const;

export type EnumTemplateSessionDebriefMode = typeof EnumTemplateSessionDebriefMode[keyof typeof EnumTemplateSessionDebriefMode];
export const EnumTimeUnit = {
  DAYS: 'DAYS',
  HOURS: 'HOURS',
  MILLISECONDS: 'MILLISECONDS',
  SECONDS: 'SECONDS'
} as const;

export type EnumTimeUnit = typeof EnumTimeUnit[keyof typeof EnumTimeUnit];
export const EnumTimingServiceConfigLogLevel = {
  CRITICAL: 'CRITICAL',
  DEBUG: 'DEBUG',
  ERROR: 'ERROR',
  INFO: 'INFO',
  NOTSET: 'NOTSET',
  WARNING: 'WARNING'
} as const;

export type EnumTimingServiceConfigLogLevel = typeof EnumTimingServiceConfigLogLevel[keyof typeof EnumTimingServiceConfigLogLevel];
export const EnumTimingServiceConfigMode = {
  MILEAGE: 'MILEAGE',
  OFFICIAL: 'OFFICIAL'
} as const;

export type EnumTimingServiceConfigMode = typeof EnumTimingServiceConfigMode[keyof typeof EnumTimingServiceConfigMode];
export const EnumToeMeasurementMethod = {
  ANGLE: 'ANGLE',
  BOTH: 'BOTH',
  LENGTH: 'LENGTH'
} as const;

export type EnumToeMeasurementMethod = typeof EnumToeMeasurementMethod[keyof typeof EnumToeMeasurementMethod];
export const EnumTorqueUnit = {
  NEWTON_METRES: 'NEWTON_METRES',
  NEWTON_MILLIMETRES: 'NEWTON_MILLIMETRES',
  POUND_FORCE_FEET: 'POUND_FORCE_FEET',
  POUND_FORCE_INCHES: 'POUND_FORCE_INCHES'
} as const;

export type EnumTorqueUnit = typeof EnumTorqueUnit[keyof typeof EnumTorqueUnit];
export const EnumTorsionRateUnit = {
  NEWTON_METRES_PER_DEGREE: 'NEWTON_METRES_PER_DEGREE',
  NEWTON_METRES_PER_RADIAN: 'NEWTON_METRES_PER_RADIAN',
  POUNDS_FEET_PER_DEGREE: 'POUNDS_FEET_PER_DEGREE',
  POUNDS_FEET_PER_RADIAN: 'POUNDS_FEET_PER_RADIAN',
  POUNDS_INCHES_PER_DEGREE: 'POUNDS_INCHES_PER_DEGREE',
  POUNDS_INCHES_PER_RADIAN: 'POUNDS_INCHES_PER_RADIAN'
} as const;

export type EnumTorsionRateUnit = typeof EnumTorsionRateUnit[keyof typeof EnumTorsionRateUnit];
/** Indicates whether the pole position is on the left- or right-hand side */
export const EnumTrackLayoutPolePosition = {
  LHS: 'LHS',
  RHS: 'RHS'
} as const;

export type EnumTrackLayoutPolePosition = typeof EnumTrackLayoutPolePosition[keyof typeof EnumTrackLayoutPolePosition];
export const EnumTrackLayoutTrackLayoutType = {
  DIRT: 'DIRT',
  OVAL: 'OVAL',
  TRACK: 'TRACK'
} as const;

export type EnumTrackLayoutTrackLayoutType = typeof EnumTrackLayoutTrackLayoutType[keyof typeof EnumTrackLayoutTrackLayoutType];
export const EnumTrackStateFlag = {
  CHEQUERED: 'CHEQUERED',
  GREEN: 'GREEN',
  PARTIAL_YELLOW: 'PARTIAL_YELLOW',
  RED: 'RED',
  YELLOW: 'YELLOW'
} as const;

export type EnumTrackStateFlag = typeof EnumTrackStateFlag[keyof typeof EnumTrackStateFlag];
export const EnumTrackableWarningDirection = {
  GREATER_THAN: 'GREATER_THAN',
  LESS_THAN: 'LESS_THAN'
} as const;

export type EnumTrackableWarningDirection = typeof EnumTrackableWarningDirection[keyof typeof EnumTrackableWarningDirection];
export const EnumTrackingItemOperator = {
  EQUAL: 'EQUAL',
  GREATER_THAN: 'GREATER_THAN',
  GREATER_THAN_OR_EQUAL: 'GREATER_THAN_OR_EQUAL',
  LESS_THAN: 'LESS_THAN',
  LESS_THAN_OR_EQUAL: 'LESS_THAN_OR_EQUAL'
} as const;

export type EnumTrackingItemOperator = typeof EnumTrackingItemOperator[keyof typeof EnumTrackingItemOperator];
export const EnumTrackingRecordGeneralType = {
  GENERAL: 'GENERAL',
  OVERRIDE: 'OVERRIDE',
  VALUE: 'VALUE'
} as const;

export type EnumTrackingRecordGeneralType = typeof EnumTrackingRecordGeneralType[keyof typeof EnumTrackingRecordGeneralType];
export const EnumTrackingRecordOverrideType = {
  GENERAL: 'GENERAL',
  OVERRIDE: 'OVERRIDE',
  VALUE: 'VALUE'
} as const;

export type EnumTrackingRecordOverrideType = typeof EnumTrackingRecordOverrideType[keyof typeof EnumTrackingRecordOverrideType];
export const EnumTrackingRecordType = {
  GENERAL: 'GENERAL',
  OVERRIDE: 'OVERRIDE',
  VALUE: 'VALUE'
} as const;

export type EnumTrackingRecordType = typeof EnumTrackingRecordType[keyof typeof EnumTrackingRecordType];
export const EnumTrackingRecordValueType = {
  GENERAL: 'GENERAL',
  OVERRIDE: 'OVERRIDE',
  VALUE: 'VALUE'
} as const;

export type EnumTrackingRecordValueType = typeof EnumTrackingRecordValueType[keyof typeof EnumTrackingRecordValueType];
export const EnumTrackingSourceAliasAliasType = {
  CarDataKPI: 'CarDataKPI',
  Manual: 'Manual',
  RunDistance: 'RunDistance',
  RunTime: 'RunTime'
} as const;

export type EnumTrackingSourceAliasAliasType = typeof EnumTrackingSourceAliasAliasType[keyof typeof EnumTrackingSourceAliasAliasType];
export const EnumTypedUnitType = {
  ACCELERATION: 'ACCELERATION',
  ANGLE: 'ANGLE',
  ANGULAR_ACCELERATION: 'ANGULAR_ACCELERATION',
  ANGULAR_COMPLIANCE: 'ANGULAR_COMPLIANCE',
  ANGULAR_TORQUE_COMPLIANCE: 'ANGULAR_TORQUE_COMPLIANCE',
  ANGULAR_VELOCITY: 'ANGULAR_VELOCITY',
  COMPLIANCE: 'COMPLIANCE',
  ENERGY: 'ENERGY',
  FORCE: 'FORCE',
  INERTIA: 'INERTIA',
  LENGTH: 'LENGTH',
  MASS: 'MASS',
  NUMBER: 'NUMBER',
  POWER: 'POWER',
  PRESSURE: 'PRESSURE',
  RATIO: 'RATIO',
  SPRING_RATE: 'SPRING_RATE',
  STEERING_RACK_RATIO: 'STEERING_RACK_RATIO',
  STRING: 'STRING',
  TEMPERATURE: 'TEMPERATURE',
  TIME: 'TIME',
  TORQUE: 'TORQUE',
  TORSION_RATE: 'TORSION_RATE',
  VELOCITY: 'VELOCITY',
  VOLUME: 'VOLUME'
} as const;

export type EnumTypedUnitType = typeof EnumTypedUnitType[keyof typeof EnumTypedUnitType];
export const EnumTyreAxle = {
  BOTH: 'BOTH',
  FRONT: 'FRONT',
  REAR: 'REAR'
} as const;

export type EnumTyreAxle = typeof EnumTyreAxle[keyof typeof EnumTyreAxle];
export const EnumTyreInitialCondition = {
  NEW: 'NEW',
  SCRUBBED: 'SCRUBBED',
  USED: 'USED'
} as const;

export type EnumTyreInitialCondition = typeof EnumTyreInitialCondition[keyof typeof EnumTyreInitialCondition];
export const EnumTyreTableField = {
  H_TYRE_TREAD: 'H_TYRE_TREAD',
  H_TYRE_WEAR: 'H_TYRE_WEAR',
  PRE_RUN_MILEAGE: 'PRE_RUN_MILEAGE',
  P_TYRE: 'P_TYRE',
  P_TYRE_BUILD: 'P_TYRE_BUILD',
  P_TYRE_MINIMUM: 'P_TYRE_MINIMUM',
  P_TYRE_POST_RUN: 'P_TYRE_POST_RUN',
  P_TYRE_POST_RUN_BLEED: 'P_TYRE_POST_RUN_BLEED',
  P_TYRE_PRE_RUN_BLEED: 'P_TYRE_PRE_RUN_BLEED',
  P_TYRE_REFERENCE: 'P_TYRE_REFERENCE',
  P_TYRE_SET_DOWN: 'P_TYRE_SET_DOWN',
  P_TYRE_START_RUN: 'P_TYRE_START_RUN',
  P_TYRE_TARGET: 'P_TYRE_TARGET',
  TYRE_SELECTOR: 'TYRE_SELECTOR',
  TYRE_SET_SELECTOR: 'TYRE_SET_SELECTOR',
  TYRE_STAGGER: 'TYRE_STAGGER',
  T_AIR_REFERENCE: 'T_AIR_REFERENCE',
  T_TRACK_REFERENCE: 'T_TRACK_REFERENCE',
  T_TYRE: 'T_TYRE',
  T_TYRE_PARC_FERME_EXPECTED: 'T_TYRE_PARC_FERME_EXPECTED',
  T_TYRE_POST_RUN: 'T_TYRE_POST_RUN',
  T_TYRE_POST_RUN_BLEED: 'T_TYRE_POST_RUN_BLEED',
  T_TYRE_REFERENCE: 'T_TYRE_REFERENCE',
  T_TYRE_SET_DOWN: 'T_TYRE_SET_DOWN',
  T_TYRE_SURFACE: 'T_TYRE_SURFACE'
} as const;

export type EnumTyreTableField = typeof EnumTyreTableField[keyof typeof EnumTyreTableField];
export const EnumUnitSystem = {
  IMPERIAL: 'IMPERIAL',
  METRIC: 'METRIC'
} as const;

export type EnumUnitSystem = typeof EnumUnitSystem[keyof typeof EnumUnitSystem];
export const EnumUntypedUnit = {
  NONE: 'NONE',
  NUMBER: 'NUMBER',
  STRING: 'STRING'
} as const;

export type EnumUntypedUnit = typeof EnumUntypedUnit[keyof typeof EnumUntypedUnit];
export const EnumUserEnumAssemblyTypeType = {
  USER_ENUM_ASSEMBLY_TYPE: 'USER_ENUM_ASSEMBLY_TYPE'
} as const;

export type EnumUserEnumAssemblyTypeType = typeof EnumUserEnumAssemblyTypeType[keyof typeof EnumUserEnumAssemblyTypeType];
export const EnumUserEnumBuildSheetGroupType = {
  USER_ENUM_BUILDSHEET_GROUP: 'USER_ENUM_BUILDSHEET_GROUP'
} as const;

export type EnumUserEnumBuildSheetGroupType = typeof EnumUserEnumBuildSheetGroupType[keyof typeof EnumUserEnumBuildSheetGroupType];
export const EnumUserEnumPartStatusType = {
  USER_ENUM_PART_STATUS: 'USER_ENUM_PART_STATUS'
} as const;

export type EnumUserEnumPartStatusType = typeof EnumUserEnumPartStatusType[keyof typeof EnumUserEnumPartStatusType];
export const EnumUserEnumPartTypeType = {
  USER_ENUM_PART_TYPE: 'USER_ENUM_PART_TYPE'
} as const;

export type EnumUserEnumPartTypeType = typeof EnumUserEnumPartTypeType[keyof typeof EnumUserEnumPartTypeType];
export const EnumUserEnumRunPlannerActionItemType = {
  USER_ENUM_RUN_PLANNER_ACTION_ITEM: 'USER_ENUM_RUN_PLANNER_ACTION_ITEM'
} as const;

export type EnumUserEnumRunPlannerActionItemType = typeof EnumUserEnumRunPlannerActionItemType[keyof typeof EnumUserEnumRunPlannerActionItemType];
export const EnumUserEnumSimulationDriveFileTypeType = {
  USER_ENUM_SIMULATION_DRIVE_FILE_TYPE: 'USER_ENUM_SIMULATION_DRIVE_FILE_TYPE'
} as const;

export type EnumUserEnumSimulationDriveFileTypeType = typeof EnumUserEnumSimulationDriveFileTypeType[keyof typeof EnumUserEnumSimulationDriveFileTypeType];
export const EnumUserEnumTrackingSeverityType = {
  USER_ENUM_TRACKING_SEVERITY: 'USER_ENUM_TRACKING_SEVERITY'
} as const;

export type EnumUserEnumTrackingSeverityType = typeof EnumUserEnumTrackingSeverityType[keyof typeof EnumUserEnumTrackingSeverityType];
export const EnumUserEnumType = {
  USER_ENUM_ASSEMBLY_TYPE: 'USER_ENUM_ASSEMBLY_TYPE',
  USER_ENUM_BUILDSHEET_GROUP: 'USER_ENUM_BUILDSHEET_GROUP',
  USER_ENUM_PART_STATUS: 'USER_ENUM_PART_STATUS',
  USER_ENUM_PART_TYPE: 'USER_ENUM_PART_TYPE',
  USER_ENUM_RUN_PLANNER_ACTION_ITEM: 'USER_ENUM_RUN_PLANNER_ACTION_ITEM',
  USER_ENUM_SIMULATION_DRIVE_FILE_TYPE: 'USER_ENUM_SIMULATION_DRIVE_FILE_TYPE',
  USER_ENUM_TRACKING_SEVERITY: 'USER_ENUM_TRACKING_SEVERITY'
} as const;

export type EnumUserEnumType = typeof EnumUserEnumType[keyof typeof EnumUserEnumType];
export const EnumVelocityUnit = {
  FEET_PER_SECOND: 'FEET_PER_SECOND',
  KILOMETRES_PER_HOUR: 'KILOMETRES_PER_HOUR',
  METRES_PER_SECOND: 'METRES_PER_SECOND',
  MILES_PER_HOUR: 'MILES_PER_HOUR'
} as const;

export type EnumVelocityUnit = typeof EnumVelocityUnit[keyof typeof EnumVelocityUnit];
export const EnumVolumeUnit = {
  GALLONS: 'GALLONS',
  LITRES: 'LITRES',
  METRES_CUBED: 'METRES_CUBED',
  MILLILITRES: 'MILLILITRES'
} as const;

export type EnumVolumeUnit = typeof EnumVolumeUnit[keyof typeof EnumVolumeUnit];
export const EnumWeatherBlockField = {
  AIR_DENSITY: 'AIR_DENSITY',
  AMBIENT_CONDITION: 'AMBIENT_CONDITION',
  HUMIDITY: 'HUMIDITY',
  PRESSURE: 'PRESSURE',
  TRACK_CONDITION: 'TRACK_CONDITION',
  T_AMBIENT: 'T_AMBIENT',
  T_AMBIENT_OFFICIAL: 'T_AMBIENT_OFFICIAL',
  T_TRACK: 'T_TRACK',
  T_TRACK_OFFICIAL: 'T_TRACK_OFFICIAL'
} as const;

export type EnumWeatherBlockField = typeof EnumWeatherBlockField[keyof typeof EnumWeatherBlockField];
/** Location or weather station */
export const EnumWeatherServiceConfigRequestType = {
  LOCATION: 'LOCATION',
  WEATHER_STATION: 'WEATHER_STATION'
} as const;

export type EnumWeatherServiceConfigRequestType = typeof EnumWeatherServiceConfigRequestType[keyof typeof EnumWeatherServiceConfigRequestType];
/** Weather client to specify the source where to retrieve the data from. */
export const EnumWeatherServiceConfigSource = {
  METEOMATICS: 'METEOMATICS',
  ONE_TIMING: 'ONE_TIMING',
  OPEN_WEATHER_MAP: 'OPEN_WEATHER_MAP',
  TOMORROW_IO: 'TOMORROW_IO',
  WEATHER_LINK: 'WEATHER_LINK',
  WEATHER_UNDERGROUND: 'WEATHER_UNDERGROUND'
} as const;

export type EnumWeatherServiceConfigSource = typeof EnumWeatherServiceConfigSource[keyof typeof EnumWeatherServiceConfigSource];
export const EnumWeatherServiceConfigType = {
  HISTORICAL: 'HISTORICAL',
  MEASUREMENT: 'MEASUREMENT',
  PREDICTION: 'PREDICTION'
} as const;

export type EnumWeatherServiceConfigType = typeof EnumWeatherServiceConfigType[keyof typeof EnumWeatherServiceConfigType];
export const EnumWeatherSources = {
  METEOMATICS: 'METEOMATICS',
  ONE_TIMING: 'ONE_TIMING',
  OPEN_WEATHER_MAP: 'OPEN_WEATHER_MAP',
  TOMORROW_IO: 'TOMORROW_IO',
  WEATHER_LINK: 'WEATHER_LINK',
  WEATHER_UNDERGROUND: 'WEATHER_UNDERGROUND'
} as const;

export type EnumWeatherSources = typeof EnumWeatherSources[keyof typeof EnumWeatherSources];
export const EnumWeatherType = {
  HISTORICAL: 'HISTORICAL',
  MEASUREMENT: 'MEASUREMENT',
  PREDICTION: 'PREDICTION'
} as const;

export type EnumWeatherType = typeof EnumWeatherType[keyof typeof EnumWeatherType];
/** Field to target with this mutation. */
export const EventContestantField = {
  /** → `chassisIDs` */
  CHASSIS: 'CHASSIS',
  /** → `driverIDs` */
  DRIVERS: 'DRIVERS'
} as const;

export type EventContestantField = typeof EventContestantField[keyof typeof EventContestantField];
export const IssueAction = {
  CLOSE: 'CLOSE',
  REOPEN: 'REOPEN'
} as const;

export type IssueAction = typeof IssueAction[keyof typeof IssueAction];
export const IssueStatus = {
  ACKNOWLEDGED: 'ACKNOWLEDGED',
  CANCELLED: 'CANCELLED',
  CLOSED: 'CLOSED',
  OPEN: 'OPEN'
} as const;

export type IssueStatus = typeof IssueStatus[keyof typeof IssueStatus];
export const JobAction = {
  ACKNOWLEDGE: 'ACKNOWLEDGE',
  CANCEL: 'CANCEL',
  CLOSE: 'CLOSE',
  REINSTATE: 'REINSTATE',
  REOPEN: 'REOPEN',
  UNACKNOWLEDGE: 'UNACKNOWLEDGE'
} as const;

export type JobAction = typeof JobAction[keyof typeof JobAction];
export const JobStatus = {
  ACKNOWLEDGED: 'ACKNOWLEDGED',
  CANCELLED: 'CANCELLED',
  CLOSED: 'CLOSED',
  OPEN: 'OPEN'
} as const;

export type JobStatus = typeof JobStatus[keyof typeof JobStatus];
export const OneTimingWeatherServiceStatus = {
  /** Stopped due to error. See log for details. */
  ERROR: 'ERROR',
  /** Stopped due to end of event. */
  FINISHED: 'FINISHED',
  /** Ready to receive a start command. */
  READY: 'READY',
  /** Watching and acting on timing data. */
  RUNNING: 'RUNNING',
  /** Stopped by user. */
  STOPPED: 'STOPPED'
} as const;

export type OneTimingWeatherServiceStatus = typeof OneTimingWeatherServiceStatus[keyof typeof OneTimingWeatherServiceStatus];
export const RunPlanRunPriority = {
  PRIO1_MAXIMUM: 'PRIO1_MAXIMUM',
  PRIO2_HIGH: 'PRIO2_HIGH',
  PRIO3_MEDIUM: 'PRIO3_MEDIUM',
  PRIO4_LOW: 'PRIO4_LOW',
  PRIO5_NONE: 'PRIO5_NONE'
} as const;

export type RunPlanRunPriority = typeof RunPlanRunPriority[keyof typeof RunPlanRunPriority];
/** Field to target with this mutation. */
export const SessionContestantField = {
  /** → `chassisIDs` */
  CHASSIS: 'CHASSIS',
  /** → `driverIDs` */
  DRIVERS: 'DRIVERS'
} as const;

export type SessionContestantField = typeof SessionContestantField[keyof typeof SessionContestantField];
export const SortFindManyAssemblyInput = {
  CARSETUPID_ASC: 'CARSETUPID_ASC',
  CARSETUPID_DESC: 'CARSETUPID_DESC',
  CHASSISPARTID_ASC: 'CHASSISPARTID_ASC',
  CHASSISPARTID_DESC: 'CHASSISPARTID_DESC',
  CHASSISSPECID_ASC: 'CHASSISSPECID_ASC',
  CHASSISSPECID_DESC: 'CHASSISSPECID_DESC',
  CREATEDAT_ASC: 'CREATEDAT_ASC',
  CREATEDAT_DESC: 'CREATEDAT_DESC',
  CURRENT_ASC: 'CURRENT_ASC',
  CURRENT_DESC: 'CURRENT_DESC',
  DECOMMISSIONED_ASC: 'DECOMMISSIONED_ASC',
  DECOMMISSIONED_DESC: 'DECOMMISSIONED_DESC',
  LOCATIONID_ASC: 'LOCATIONID_ASC',
  LOCATIONID_DESC: 'LOCATIONID_DESC',
  NAME_ASC: 'NAME_ASC',
  NAME_DESC: 'NAME_DESC',
  NESTEDPARTINSTANCEIDS_ASC: 'NESTEDPARTINSTANCEIDS_ASC',
  NESTEDPARTINSTANCEIDS_DESC: 'NESTEDPARTINSTANCEIDS_DESC',
  PARENTID_ASC: 'PARENTID_ASC',
  PARENTID_DESC: 'PARENTID_DESC',
  PARTINSTANCEIDS_ASC: 'PARTINSTANCEIDS_ASC',
  PARTINSTANCEIDS_DESC: 'PARTINSTANCEIDS_DESC',
  REFERENCE_ASC: 'REFERENCE_ASC',
  REFERENCE_DESC: 'REFERENCE_DESC',
  TYPE_ASC: 'TYPE_ASC',
  TYPE_DESC: 'TYPE_DESC',
  UPDATEDAT_ASC: 'UPDATEDAT_ASC',
  UPDATEDAT_DESC: 'UPDATEDAT_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyAssemblyInput = typeof SortFindManyAssemblyInput[keyof typeof SortFindManyAssemblyInput];
export const SortFindManyAssemblyTemplateInput = {
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyAssemblyTemplateInput = typeof SortFindManyAssemblyTemplateInput[keyof typeof SortFindManyAssemblyTemplateInput];
export const SortFindManyBestValuesInput = {
  CONTESTANTID_ASC: 'CONTESTANTID_ASC',
  CONTESTANTID_DESC: 'CONTESTANTID_DESC',
  DRIVERID_ASC: 'DRIVERID_ASC',
  DRIVERID_DESC: 'DRIVERID_DESC',
  SESSIONID_ASC: 'SESSIONID_ASC',
  SESSIONID_DESC: 'SESSIONID_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyBestValuesInput = typeof SortFindManyBestValuesInput[keyof typeof SortFindManyBestValuesInput];
export const SortFindManyBopInput = {
  NAME_ASC: 'NAME_ASC',
  NAME_DESC: 'NAME_DESC',
  SESSIONID_ASC: 'SESSIONID_ASC',
  SESSIONID_DESC: 'SESSIONID_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyBopInput = typeof SortFindManyBopInput[keyof typeof SortFindManyBopInput];
export const SortFindManyBuildSheetStyleInput = {
  AUTHORID_ASC: 'AUTHORID_ASC',
  AUTHORID_DESC: 'AUTHORID_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyBuildSheetStyleInput = typeof SortFindManyBuildSheetStyleInput[keyof typeof SortFindManyBuildSheetStyleInput];
export const SortFindManyCalculationInput = {
  NAME_ASC: 'NAME_ASC',
  NAME_DESC: 'NAME_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyCalculationInput = typeof SortFindManyCalculationInput[keyof typeof SortFindManyCalculationInput];
export const SortFindManyCarDataServiceConfigInput = {
  ACTIVE_ASC: 'ACTIVE_ASC',
  ACTIVE_DESC: 'ACTIVE_DESC',
  NAME_ASC: 'NAME_ASC',
  NAME_DESC: 'NAME_DESC',
  RACESERIESID_ASC: 'RACESERIESID_ASC',
  RACESERIESID_DESC: 'RACESERIESID_DESC',
  VERSION_ASC: 'VERSION_ASC',
  VERSION_DESC: 'VERSION_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyCarDataServiceConfigInput = typeof SortFindManyCarDataServiceConfigInput[keyof typeof SortFindManyCarDataServiceConfigInput];
export const SortFindManyCarSetupInput = {
  AUTHORID_ASC: 'AUTHORID_ASC',
  AUTHORID_DESC: 'AUTHORID_DESC',
  CHASSISASSEMBLYID_ASC: 'CHASSISASSEMBLYID_ASC',
  CHASSISASSEMBLYID_DESC: 'CHASSISASSEMBLYID_DESC',
  CHASSISID_ASC: 'CHASSISID_ASC',
  CHASSISID_DESC: 'CHASSISID_DESC',
  CHASSISSPECID_ASC: 'CHASSISSPECID_ASC',
  CHASSISSPECID_DESC: 'CHASSISSPECID_DESC',
  CHASSISSPECROOTID_ASC: 'CHASSISSPECROOTID_ASC',
  CHASSISSPECROOTID_DESC: 'CHASSISSPECROOTID_DESC',
  DRIVERID_ASC: 'DRIVERID_ASC',
  DRIVERID_DESC: 'DRIVERID_DESC',
  ENGINEERID_ASC: 'ENGINEERID_ASC',
  ENGINEERID_DESC: 'ENGINEERID_DESC',
  RUNSHEETID_ASC: 'RUNSHEETID_ASC',
  RUNSHEETID_DESC: 'RUNSHEETID_DESC',
  TEAMID_ASC: 'TEAMID_ASC',
  TEAMID_DESC: 'TEAMID_DESC',
  TIME_ASC: 'TIME_ASC',
  TIME_DESC: 'TIME_DESC',
  TITLE_ASC: 'TITLE_ASC',
  TITLE_DESC: 'TITLE_DESC',
  TYRESETID_ASC: 'TYRESETID_ASC',
  TYRESETID_DESC: 'TYRESETID_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyCarSetupInput = typeof SortFindManyCarSetupInput[keyof typeof SortFindManyCarSetupInput];
export const SortFindManyChassisInput = {
  MANUFACTURERPARTID_ASC: 'MANUFACTURERPARTID_ASC',
  MANUFACTURERPARTID_DESC: 'MANUFACTURERPARTID_DESC',
  ROOTSPECIFICATIONID_ASC: 'ROOTSPECIFICATIONID_ASC',
  ROOTSPECIFICATIONID_DESC: 'ROOTSPECIFICATIONID_DESC',
  SETUPSHEETSTYLE_ASC: 'SETUPSHEETSTYLE_ASC',
  SETUPSHEETSTYLE_DESC: 'SETUPSHEETSTYLE_DESC',
  SPECIFICATIONID_ASC: 'SPECIFICATIONID_ASC',
  SPECIFICATIONID_DESC: 'SPECIFICATIONID_DESC',
  TYPE_ASC: 'TYPE_ASC',
  TYPE_DESC: 'TYPE_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyChassisInput = typeof SortFindManyChassisInput[keyof typeof SortFindManyChassisInput];
export const SortFindManyChassisMeasurementInput = {
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyChassisMeasurementInput = typeof SortFindManyChassisMeasurementInput[keyof typeof SortFindManyChassisMeasurementInput];
export const SortFindManyContestantInput = {
  CHASSISNUMBER_ASC: 'CHASSISNUMBER_ASC',
  CHASSISNUMBER_DESC: 'CHASSISNUMBER_DESC',
  CLASS_ASC: 'CLASS_ASC',
  CLASS_DESC: 'CLASS_DESC',
  ELIGIBLEFORPOINTS_ASC: 'ELIGIBLEFORPOINTS_ASC',
  ELIGIBLEFORPOINTS_DESC: 'ELIGIBLEFORPOINTS_DESC',
  HIDDEN_ASC: 'HIDDEN_ASC',
  HIDDEN_DESC: 'HIDDEN_DESC',
  SEASONID_ASC: 'SEASONID_ASC',
  SEASONID_DESC: 'SEASONID_DESC',
  SEASONID__STARTNUMBER_ASC: 'SEASONID__STARTNUMBER_ASC',
  SEASONID__STARTNUMBER_DESC: 'SEASONID__STARTNUMBER_DESC',
  STARTNUMBER_ASC: 'STARTNUMBER_ASC',
  STARTNUMBER_DESC: 'STARTNUMBER_DESC',
  TEAMID_ASC: 'TEAMID_ASC',
  TEAMID_DESC: 'TEAMID_DESC',
  THIRDPARTYCONTESTANTID_ASC: 'THIRDPARTYCONTESTANTID_ASC',
  THIRDPARTYCONTESTANTID_DESC: 'THIRDPARTYCONTESTANTID_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyContestantInput = typeof SortFindManyContestantInput[keyof typeof SortFindManyContestantInput];
export const SortFindManyDepartmentInput = {
  NAME_ASC: 'NAME_ASC',
  NAME_DESC: 'NAME_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyDepartmentInput = typeof SortFindManyDepartmentInput[keyof typeof SortFindManyDepartmentInput];
export const SortFindManyDynoConfigInput = {
  NAME_ASC: 'NAME_ASC',
  NAME_DESC: 'NAME_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyDynoConfigInput = typeof SortFindManyDynoConfigInput[keyof typeof SortFindManyDynoConfigInput];
export const SortFindManyEventInput = {
  NAME_ASC: 'NAME_ASC',
  NAME_DESC: 'NAME_DESC',
  SEASONID_ASC: 'SEASONID_ASC',
  SEASONID_DESC: 'SEASONID_DESC',
  TEVENTEND_ASC: 'TEVENTEND_ASC',
  TEVENTEND_DESC: 'TEVENTEND_DESC',
  TEVENTSTART_ASC: 'TEVENTSTART_ASC',
  TEVENTSTART_DESC: 'TEVENTSTART_DESC',
  THIRDPARTYEVENTID_ASC: 'THIRDPARTYEVENTID_ASC',
  THIRDPARTYEVENTID_DESC: 'THIRDPARTYEVENTID_DESC',
  TLAPAVERAGE_ASC: 'TLAPAVERAGE_ASC',
  TLAPAVERAGE_DESC: 'TLAPAVERAGE_DESC',
  TRACKID_ASC: 'TRACKID_ASC',
  TRACKID_DESC: 'TRACKID_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyEventInput = typeof SortFindManyEventInput[keyof typeof SortFindManyEventInput];
export const SortFindManyFlexLayoutConfigInput = {
  AUTHORID_ASC: 'AUTHORID_ASC',
  AUTHORID_DESC: 'AUTHORID_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyFlexLayoutConfigInput = typeof SortFindManyFlexLayoutConfigInput[keyof typeof SortFindManyFlexLayoutConfigInput];
export const SortFindManyIssueQueryInput = {
  AREA_ASC: 'AREA_ASC',
  AREA_DESC: 'AREA_DESC',
  ASSIGNEEIDS_ASC: 'ASSIGNEEIDS_ASC',
  ASSIGNEEIDS_DESC: 'ASSIGNEEIDS_DESC',
  CATEGORY_ASC: 'CATEGORY_ASC',
  CATEGORY_DESC: 'CATEGORY_DESC',
  CREATEDAT_ASC: 'CREATEDAT_ASC',
  CREATEDAT_DESC: 'CREATEDAT_DESC',
  CREATED_BY_NAME_ASC: 'CREATED_BY_NAME_ASC',
  CREATED_BY_NAME_DESC: 'CREATED_BY_NAME_DESC',
  DEPARTMENT_NAME_ASC: 'DEPARTMENT_NAME_ASC',
  DEPARTMENT_NAME_DESC: 'DEPARTMENT_NAME_DESC',
  DESCRIPTION_ASC: 'DESCRIPTION_ASC',
  DESCRIPTION_DESC: 'DESCRIPTION_DESC',
  INDEX_ASC: 'INDEX_ASC',
  INDEX_DESC: 'INDEX_DESC',
  ISSUESTATUS_ASC: 'ISSUESTATUS_ASC',
  ISSUESTATUS_DESC: 'ISSUESTATUS_DESC',
  NUMBER_ASC: 'NUMBER_ASC',
  NUMBER_DESC: 'NUMBER_DESC',
  PRIMARYTAGID_ASC: 'PRIMARYTAGID_ASC',
  PRIMARYTAGID_DESC: 'PRIMARYTAGID_DESC',
  PRIMARYTAGLABELSORT_ASC: 'PRIMARYTAGLABELSORT_ASC',
  PRIMARYTAGLABELSORT_DESC: 'PRIMARYTAGLABELSORT_DESC',
  PRIMARY_ASSIGNEE_NAME_ASC: 'PRIMARY_ASSIGNEE_NAME_ASC',
  PRIMARY_ASSIGNEE_NAME_DESC: 'PRIMARY_ASSIGNEE_NAME_DESC',
  PRIMARY_TAG_LABEL_ASC: 'PRIMARY_TAG_LABEL_ASC',
  PRIMARY_TAG_LABEL_DESC: 'PRIMARY_TAG_LABEL_DESC',
  PRIMARY_TEAM_NAME_ASC: 'PRIMARY_TEAM_NAME_ASC',
  PRIMARY_TEAM_NAME_DESC: 'PRIMARY_TEAM_NAME_DESC',
  PRIORITY_ASC: 'PRIORITY_ASC',
  PRIORITY_DESC: 'PRIORITY_DESC',
  RUNSHEETID_ASC: 'RUNSHEETID_ASC',
  RUNSHEETID_DESC: 'RUNSHEETID_DESC',
  UPDATEDAT_ASC: 'UPDATEDAT_ASC',
  UPDATEDAT_DESC: 'UPDATEDAT_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyIssueQueryInput = typeof SortFindManyIssueQueryInput[keyof typeof SortFindManyIssueQueryInput];
export const SortFindManyJobInput = {
  ASSIGNEEIDS_ASC: 'ASSIGNEEIDS_ASC',
  ASSIGNEEIDS_DESC: 'ASSIGNEEIDS_DESC',
  CATEGORY_ASC: 'CATEGORY_ASC',
  CATEGORY_DESC: 'CATEGORY_DESC',
  DESCRIPTION_ASC: 'DESCRIPTION_ASC',
  DESCRIPTION_DESC: 'DESCRIPTION_DESC',
  INDEX_ASC: 'INDEX_ASC',
  INDEX_DESC: 'INDEX_DESC',
  NUMBER_ASC: 'NUMBER_ASC',
  NUMBER_DESC: 'NUMBER_DESC',
  PARENTID_ASC: 'PARENTID_ASC',
  PARENTID_DESC: 'PARENTID_DESC',
  PRIORITY_ASC: 'PRIORITY_ASC',
  PRIORITY_DESC: 'PRIORITY_DESC',
  RUNSHEETID_ASC: 'RUNSHEETID_ASC',
  RUNSHEETID_DESC: 'RUNSHEETID_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyJobInput = typeof SortFindManyJobInput[keyof typeof SortFindManyJobInput];
export const SortFindManyLapInput = {
  BLAPCANCELLED_ASC: 'BLAPCANCELLED_ASC',
  BLAPCANCELLED_DESC: 'BLAPCANCELLED_DESC',
  BLAPISSLOW_ASC: 'BLAPISSLOW_ASC',
  BLAPISSLOW_DESC: 'BLAPISSLOW_DESC',
  BPITIN_ASC: 'BPITIN_ASC',
  BPITIN_DESC: 'BPITIN_DESC',
  BPITOUT_ASC: 'BPITOUT_ASC',
  BPITOUT_DESC: 'BPITOUT_DESC',
  CONTESTANTID_ASC: 'CONTESTANTID_ASC',
  CONTESTANTID_DESC: 'CONTESTANTID_DESC',
  NLAPRUNCARDATA_ASC: 'NLAPRUNCARDATA_ASC',
  NLAPRUNCARDATA_DESC: 'NLAPRUNCARDATA_DESC',
  NLAPRUNMANUAL_ASC: 'NLAPRUNMANUAL_ASC',
  NLAPRUNMANUAL_DESC: 'NLAPRUNMANUAL_DESC',
  NLAPRUN_ASC: 'NLAPRUN_ASC',
  NLAPRUN_DESC: 'NLAPRUN_DESC',
  NLAPSESSIONCARDATA_ASC: 'NLAPSESSIONCARDATA_ASC',
  NLAPSESSIONCARDATA_DESC: 'NLAPSESSIONCARDATA_DESC',
  NLAPSESSIONMANUAL_ASC: 'NLAPSESSIONMANUAL_ASC',
  NLAPSESSIONMANUAL_DESC: 'NLAPSESSIONMANUAL_DESC',
  NLAPSESSION_ASC: 'NLAPSESSION_ASC',
  NLAPSESSION_DESC: 'NLAPSESSION_DESC',
  NLAPSTINTCARDATA_ASC: 'NLAPSTINTCARDATA_ASC',
  NLAPSTINTCARDATA_DESC: 'NLAPSTINTCARDATA_DESC',
  NLAPSTINTMANUAL_ASC: 'NLAPSTINTMANUAL_ASC',
  NLAPSTINTMANUAL_DESC: 'NLAPSTINTMANUAL_DESC',
  NLAPSTINT_ASC: 'NLAPSTINT_ASC',
  NLAPSTINT_DESC: 'NLAPSTINT_DESC',
  RUNSHEETID_ASC: 'RUNSHEETID_ASC',
  RUNSHEETID_DESC: 'RUNSHEETID_DESC',
  SESSIONID_ASC: 'SESSIONID_ASC',
  SESSIONID_DESC: 'SESSIONID_DESC',
  TDAY_ASC: 'TDAY_ASC',
  TDAY_DESC: 'TDAY_DESC',
  TLAPMANUAL_ASC: 'TLAPMANUAL_ASC',
  TLAPMANUAL_DESC: 'TLAPMANUAL_DESC',
  TLAPMAX_ASC: 'TLAPMAX_ASC',
  TLAPMAX_DESC: 'TLAPMAX_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyLapInput = typeof SortFindManyLapInput[keyof typeof SortFindManyLapInput];
export const SortFindManyLapSequenceInput = {
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyLapSequenceInput = typeof SortFindManyLapSequenceInput[keyof typeof SortFindManyLapSequenceInput];
export const SortFindManyLapSequenceTemplateInput = {
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyLapSequenceTemplateInput = typeof SortFindManyLapSequenceTemplateInput[keyof typeof SortFindManyLapSequenceTemplateInput];
export const SortFindManyLocationInput = {
  NAME_ASC: 'NAME_ASC',
  NAME_DESC: 'NAME_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyLocationInput = typeof SortFindManyLocationInput[keyof typeof SortFindManyLocationInput];
export const SortFindManyLogInput = {
  CREATEDAT_ASC: 'CREATEDAT_ASC',
  CREATEDAT_DESC: 'CREATEDAT_DESC',
  LOGLEVEL_ASC: 'LOGLEVEL_ASC',
  LOGLEVEL_DESC: 'LOGLEVEL_DESC',
  SERVICESOURCE_ASC: 'SERVICESOURCE_ASC',
  SERVICESOURCE_DESC: 'SERVICESOURCE_DESC',
  UPDATEDAT_ASC: 'UPDATEDAT_ASC',
  UPDATEDAT_DESC: 'UPDATEDAT_DESC',
  USERID_ASC: 'USERID_ASC',
  USERID_DESC: 'USERID_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyLogInput = typeof SortFindManyLogInput[keyof typeof SortFindManyLogInput];
export const SortFindManyManufacturerInput = {
  NAME_ASC: 'NAME_ASC',
  NAME_DESC: 'NAME_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyManufacturerInput = typeof SortFindManyManufacturerInput[keyof typeof SortFindManyManufacturerInput];
export const SortFindManyOneTimingWeatherServiceConfigInput = {
  NAME_ASC: 'NAME_ASC',
  NAME_DESC: 'NAME_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyOneTimingWeatherServiceConfigInput = typeof SortFindManyOneTimingWeatherServiceConfigInput[keyof typeof SortFindManyOneTimingWeatherServiceConfigInput];
export const SortFindManyPackageInput = {
  AUTHORID_ASC: 'AUTHORID_ASC',
  AUTHORID_DESC: 'AUTHORID_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyPackageInput = typeof SortFindManyPackageInput[keyof typeof SortFindManyPackageInput];
export const SortFindManyPartInput = {
  CREATEDAT_ASC: 'CREATEDAT_ASC',
  CREATEDAT_DESC: 'CREATEDAT_DESC',
  DESCRIPTION_ASC: 'DESCRIPTION_ASC',
  DESCRIPTION_DESC: 'DESCRIPTION_DESC',
  ELIGIBLEEVENTTYPES_ASC: 'ELIGIBLEEVENTTYPES_ASC',
  ELIGIBLEEVENTTYPES_DESC: 'ELIGIBLEEVENTTYPES_DESC',
  LIFETIMEMILEAGE_ASC: 'LIFETIMEMILEAGE_ASC',
  LIFETIMEMILEAGE_DESC: 'LIFETIMEMILEAGE_DESC',
  LOCATION_NAME_ASC: 'LOCATION_NAME_ASC',
  LOCATION_NAME_DESC: 'LOCATION_NAME_DESC',
  MANUFACTURERPARTID_ASC: 'MANUFACTURERPARTID_ASC',
  MANUFACTURERPARTID_DESC: 'MANUFACTURERPARTID_DESC',
  MANUFACTURERSERIALNUMBER_ASC: 'MANUFACTURERSERIALNUMBER_ASC',
  MANUFACTURERSERIALNUMBER_DESC: 'MANUFACTURERSERIALNUMBER_DESC',
  MANUFACTURER_NAME_ASC: 'MANUFACTURER_NAME_ASC',
  MANUFACTURER_NAME_DESC: 'MANUFACTURER_NAME_DESC',
  PARTNUMBER_ASC: 'PARTNUMBER_ASC',
  PARTNUMBER_DESC: 'PARTNUMBER_DESC',
  REFERENCE_ASC: 'REFERENCE_ASC',
  REFERENCE_DESC: 'REFERENCE_DESC',
  REFERENCE__ROOTSPECIFICATIONID_ASC: 'REFERENCE__ROOTSPECIFICATIONID_ASC',
  REFERENCE__ROOTSPECIFICATIONID_DESC: 'REFERENCE__ROOTSPECIFICATIONID_DESC',
  ROOTSPECIFICATIONID_ASC: 'ROOTSPECIFICATIONID_ASC',
  ROOTSPECIFICATIONID_DESC: 'ROOTSPECIFICATIONID_DESC',
  SPECIFICATIONID_ASC: 'SPECIFICATIONID_ASC',
  SPECIFICATIONID_DESC: 'SPECIFICATIONID_DESC',
  TEAMIDS_ASC: 'TEAMIDS_ASC',
  TEAMIDS_DESC: 'TEAMIDS_DESC',
  TEAMID_ASC: 'TEAMID_ASC',
  TEAMID_DESC: 'TEAMID_DESC',
  TEAM_NAME_ASC: 'TEAM_NAME_ASC',
  TEAM_NAME_DESC: 'TEAM_NAME_DESC',
  UPDATEDAT_ASC: 'UPDATEDAT_ASC',
  UPDATEDAT_DESC: 'UPDATEDAT_DESC',
  USERENUMPARTTYPEID_ASC: 'USERENUMPARTTYPEID_ASC',
  USERENUMPARTTYPEID_DESC: 'USERENUMPARTTYPEID_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyPartInput = typeof SortFindManyPartInput[keyof typeof SortFindManyPartInput];
export const SortFindManyPartInstanceInput = {
  SPECIFICATIONID_ASC: 'SPECIFICATIONID_ASC',
  SPECIFICATIONID_DESC: 'SPECIFICATIONID_DESC',
  SUPERPARENTID_ASC: 'SUPERPARENTID_ASC',
  SUPERPARENTID_DESC: 'SUPERPARENTID_DESC',
  SUPERPARENTID__SPECIFICATIONID_ASC: 'SUPERPARENTID__SPECIFICATIONID_ASC',
  SUPERPARENTID__SPECIFICATIONID_DESC: 'SUPERPARENTID__SPECIFICATIONID_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyPartInstanceInput = typeof SortFindManyPartInstanceInput[keyof typeof SortFindManyPartInstanceInput];
export const SortFindManyPersonInput = {
  ACRONYM_ASC: 'ACRONYM_ASC',
  ACRONYM_DESC: 'ACRONYM_DESC',
  BIRTHDAY_ASC: 'BIRTHDAY_ASC',
  BIRTHDAY_DESC: 'BIRTHDAY_DESC',
  EMAIL_ASC: 'EMAIL_ASC',
  EMAIL_DESC: 'EMAIL_DESC',
  ISACTIVE_ASC: 'ISACTIVE_ASC',
  ISACTIVE_DESC: 'ISACTIVE_DESC',
  NAME_ASC: 'NAME_ASC',
  NAME_DESC: 'NAME_DESC',
  ROLE_ASC: 'ROLE_ASC',
  ROLE_DESC: 'ROLE_DESC',
  TEAMID_ASC: 'TEAMID_ASC',
  TEAMID_DESC: 'TEAMID_DESC',
  TIMETRACKERAPPROVALBYPERSONID_ASC: 'TIMETRACKERAPPROVALBYPERSONID_ASC',
  TIMETRACKERAPPROVALBYPERSONID_DESC: 'TIMETRACKERAPPROVALBYPERSONID_DESC',
  USERNAME_ASC: 'USERNAME_ASC',
  USERNAME_DESC: 'USERNAME_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyPersonInput = typeof SortFindManyPersonInput[keyof typeof SortFindManyPersonInput];
export const SortFindManyPlotPageConfigInput = {
  AUTHORID_ASC: 'AUTHORID_ASC',
  AUTHORID_DESC: 'AUTHORID_DESC',
  TITLE_ASC: 'TITLE_ASC',
  TITLE_DESC: 'TITLE_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyPlotPageConfigInput = typeof SortFindManyPlotPageConfigInput[keyof typeof SortFindManyPlotPageConfigInput];
export const SortFindManyPointsSystemInput = {
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyPointsSystemInput = typeof SortFindManyPointsSystemInput[keyof typeof SortFindManyPointsSystemInput];
export const SortFindManyProjectInput = {
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyProjectInput = typeof SortFindManyProjectInput[keyof typeof SortFindManyProjectInput];
export const SortFindManyQualityCheckActionInput = {
  ASSIGNEEIDS_ASC: 'ASSIGNEEIDS_ASC',
  ASSIGNEEIDS_DESC: 'ASSIGNEEIDS_DESC',
  CATEGORY_ASC: 'CATEGORY_ASC',
  CATEGORY_DESC: 'CATEGORY_DESC',
  DESCRIPTION_ASC: 'DESCRIPTION_ASC',
  DESCRIPTION_DESC: 'DESCRIPTION_DESC',
  PRIORITY_ASC: 'PRIORITY_ASC',
  PRIORITY_DESC: 'PRIORITY_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyQualityCheckActionInput = typeof SortFindManyQualityCheckActionInput[keyof typeof SortFindManyQualityCheckActionInput];
export const SortFindManyQualityCheckInput = {
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyQualityCheckInput = typeof SortFindManyQualityCheckInput[keyof typeof SortFindManyQualityCheckInput];
export const SortFindManyRaceSeriesInput = {
  NAME_ASC: 'NAME_ASC',
  NAME_DESC: 'NAME_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyRaceSeriesInput = typeof SortFindManyRaceSeriesInput[keyof typeof SortFindManyRaceSeriesInput];
export const SortFindManyRadioMessageInput = {
  CONTESTANTID_ASC: 'CONTESTANTID_ASC',
  CONTESTANTID_DESC: 'CONTESTANTID_DESC',
  DRIVERID_ASC: 'DRIVERID_ASC',
  DRIVERID_DESC: 'DRIVERID_DESC',
  SESSIONID_ASC: 'SESSIONID_ASC',
  SESSIONID_DESC: 'SESSIONID_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyRadioMessageInput = typeof SortFindManyRadioMessageInput[keyof typeof SortFindManyRadioMessageInput];
export const SortFindManyReportNotesTemplateInput = {
  TITLE_ASC: 'TITLE_ASC',
  TITLE_DESC: 'TITLE_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyReportNotesTemplateInput = typeof SortFindManyReportNotesTemplateInput[keyof typeof SortFindManyReportNotesTemplateInput];
export const SortFindManyReportTemplateInput = {
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyReportTemplateInput = typeof SortFindManyReportTemplateInput[keyof typeof SortFindManyReportTemplateInput];
export const SortFindManyRunPlanInput = {
  CONTESTANTID_ASC: 'CONTESTANTID_ASC',
  CONTESTANTID_DESC: 'CONTESTANTID_DESC',
  SESSIONID_ASC: 'SESSIONID_ASC',
  SESSIONID_DESC: 'SESSIONID_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyRunPlanInput = typeof SortFindManyRunPlanInput[keyof typeof SortFindManyRunPlanInput];
export const SortFindManyRunSheetInput = {
  CONTESTANTID_ASC: 'CONTESTANTID_ASC',
  CONTESTANTID_DESC: 'CONTESTANTID_DESC',
  DRIVERID_ASC: 'DRIVERID_ASC',
  DRIVERID_DESC: 'DRIVERID_DESC',
  ENDTIMECDS_ASC: 'ENDTIMECDS_ASC',
  ENDTIMECDS_DESC: 'ENDTIMECDS_DESC',
  ENDTIMELTS_ASC: 'ENDTIMELTS_ASC',
  ENDTIMELTS_DESC: 'ENDTIMELTS_DESC',
  ENDTIMEMANUAL_ASC: 'ENDTIMEMANUAL_ASC',
  ENDTIMEMANUAL_DESC: 'ENDTIMEMANUAL_DESC',
  ENGINEERID_ASC: 'ENGINEERID_ASC',
  ENGINEERID_DESC: 'ENGINEERID_DESC',
  NEXTRUNSHEETID_ASC: 'NEXTRUNSHEETID_ASC',
  NEXTRUNSHEETID_DESC: 'NEXTRUNSHEETID_DESC',
  NRUNTIMING_ASC: 'NRUNTIMING_ASC',
  NRUNTIMING_DESC: 'NRUNTIMING_DESC',
  NRUN_ASC: 'NRUN_ASC',
  NRUN_DESC: 'NRUN_DESC',
  PREVRUNSHEETID_ASC: 'PREVRUNSHEETID_ASC',
  PREVRUNSHEETID_DESC: 'PREVRUNSHEETID_DESC',
  RUNSHEETSTYLEID_ASC: 'RUNSHEETSTYLEID_ASC',
  RUNSHEETSTYLEID_DESC: 'RUNSHEETSTYLEID_DESC',
  SESSIONID_ASC: 'SESSIONID_ASC',
  SESSIONID_DESC: 'SESSIONID_DESC',
  SETUPID_ASC: 'SETUPID_ASC',
  SETUPID_DESC: 'SETUPID_DESC',
  SIMRESULTIDS_ASC: 'SIMRESULTIDS_ASC',
  SIMRESULTIDS_DESC: 'SIMRESULTIDS_DESC',
  STARTTIMECDS_ASC: 'STARTTIMECDS_ASC',
  STARTTIMECDS_DESC: 'STARTTIMECDS_DESC',
  STARTTIMELTS_ASC: 'STARTTIMELTS_ASC',
  STARTTIMELTS_DESC: 'STARTTIMELTS_DESC',
  STARTTIMEMANUAL_ASC: 'STARTTIMEMANUAL_ASC',
  STARTTIMEMANUAL_DESC: 'STARTTIMEMANUAL_DESC',
  TEAMID_ASC: 'TEAMID_ASC',
  TEAMID_DESC: 'TEAMID_DESC',
  THIRDPARTYRUNID_ASC: 'THIRDPARTYRUNID_ASC',
  THIRDPARTYRUNID_DESC: 'THIRDPARTYRUNID_DESC',
  TYRECOMPOUNDTIMING_ASC: 'TYRECOMPOUNDTIMING_ASC',
  TYRECOMPOUNDTIMING_DESC: 'TYRECOMPOUNDTIMING_DESC',
  TYRESETID_ASC: 'TYRESETID_ASC',
  TYRESETID_DESC: 'TYRESETID_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyRunSheetInput = typeof SortFindManyRunSheetInput[keyof typeof SortFindManyRunSheetInput];
export const SortFindManyRunSheetStyleInput = {
  NAME_ASC: 'NAME_ASC',
  NAME_DESC: 'NAME_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyRunSheetStyleInput = typeof SortFindManyRunSheetStyleInput[keyof typeof SortFindManyRunSheetStyleInput];
export const SortFindManySandboxUnitsInput = {
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManySandboxUnitsInput = typeof SortFindManySandboxUnitsInput[keyof typeof SortFindManySandboxUnitsInput];
export const SortFindManySeasonInput = {
  NAME_ASC: 'NAME_ASC',
  NAME_DESC: 'NAME_DESC',
  RACESERIESID_ASC: 'RACESERIESID_ASC',
  RACESERIESID_DESC: 'RACESERIESID_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManySeasonInput = typeof SortFindManySeasonInput[keyof typeof SortFindManySeasonInput];
export const SortFindManySessionInput = {
  EVENTID_ASC: 'EVENTID_ASC',
  EVENTID_DESC: 'EVENTID_DESC',
  NAME_ASC: 'NAME_ASC',
  NAME_DESC: 'NAME_DESC',
  SHORTNAME_ASC: 'SHORTNAME_ASC',
  SHORTNAME_DESC: 'SHORTNAME_DESC',
  THIRDPARTYSESSIONID_ASC: 'THIRDPARTYSESSIONID_ASC',
  THIRDPARTYSESSIONID_DESC: 'THIRDPARTYSESSIONID_DESC',
  TRANSCRIBBLESESSIONID_ASC: 'TRANSCRIBBLESESSIONID_ASC',
  TRANSCRIBBLESESSIONID_DESC: 'TRANSCRIBBLESESSIONID_DESC',
  TSESSIONEND_ASC: 'TSESSIONEND_ASC',
  TSESSIONEND_DESC: 'TSESSIONEND_DESC',
  TSESSIONSTART_ASC: 'TSESSIONSTART_ASC',
  TSESSIONSTART_DESC: 'TSESSIONSTART_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManySessionInput = typeof SortFindManySessionInput[keyof typeof SortFindManySessionInput];
export const SortFindManySetupOverviewConfigInput = {
  AUTHORID_ASC: 'AUTHORID_ASC',
  AUTHORID_DESC: 'AUTHORID_DESC',
  TITLE_ASC: 'TITLE_ASC',
  TITLE_DESC: 'TITLE_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManySetupOverviewConfigInput = typeof SortFindManySetupOverviewConfigInput[keyof typeof SortFindManySetupOverviewConfigInput];
export const SortFindManySetupSheetStyleInput = {
  AUTHORID_ASC: 'AUTHORID_ASC',
  AUTHORID_DESC: 'AUTHORID_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManySetupSheetStyleInput = typeof SortFindManySetupSheetStyleInput[keyof typeof SortFindManySetupSheetStyleInput];
export const SortFindManySimRequestInput = {
  CARSETUPID_ASC: 'CARSETUPID_ASC',
  CARSETUPID_DESC: 'CARSETUPID_DESC',
  CREATEDAT_ASC: 'CREATEDAT_ASC',
  CREATEDAT_DESC: 'CREATEDAT_DESC',
  REQUESTERID_ASC: 'REQUESTERID_ASC',
  REQUESTERID_DESC: 'REQUESTERID_DESC',
  RUNSHEETID_ASC: 'RUNSHEETID_ASC',
  RUNSHEETID_DESC: 'RUNSHEETID_DESC',
  SIMRESULTID_ASC: 'SIMRESULTID_ASC',
  SIMRESULTID_DESC: 'SIMRESULTID_DESC',
  SIMTYPE_ASC: 'SIMTYPE_ASC',
  SIMTYPE_DESC: 'SIMTYPE_DESC',
  SIMULATIONSERVICE_ASC: 'SIMULATIONSERVICE_ASC',
  SIMULATIONSERVICE_DESC: 'SIMULATIONSERVICE_DESC',
  SPECIFICATIONID_ASC: 'SPECIFICATIONID_ASC',
  SPECIFICATIONID_DESC: 'SPECIFICATIONID_DESC',
  TRACKLAYOUTID_ASC: 'TRACKLAYOUTID_ASC',
  TRACKLAYOUTID_DESC: 'TRACKLAYOUTID_DESC',
  UPDATEDAT_ASC: 'UPDATEDAT_ASC',
  UPDATEDAT_DESC: 'UPDATEDAT_DESC',
  VERSION_ASC: 'VERSION_ASC',
  VERSION_DESC: 'VERSION_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManySimRequestInput = typeof SortFindManySimRequestInput[keyof typeof SortFindManySimRequestInput];
export const SortFindManySimResultInput = {
  CARSETUPID_ASC: 'CARSETUPID_ASC',
  CARSETUPID_DESC: 'CARSETUPID_DESC',
  CREATEDAT_ASC: 'CREATEDAT_ASC',
  CREATEDAT_DESC: 'CREATEDAT_DESC',
  REQUESTERID_ASC: 'REQUESTERID_ASC',
  REQUESTERID_DESC: 'REQUESTERID_DESC',
  RUNSHEETID_ASC: 'RUNSHEETID_ASC',
  RUNSHEETID_DESC: 'RUNSHEETID_DESC',
  SERVICEVERSION_ASC: 'SERVICEVERSION_ASC',
  SERVICEVERSION_DESC: 'SERVICEVERSION_DESC',
  SIMTYPE_ASC: 'SIMTYPE_ASC',
  SIMTYPE_DESC: 'SIMTYPE_DESC',
  SIMULATIONSERVICE_ASC: 'SIMULATIONSERVICE_ASC',
  SIMULATIONSERVICE_DESC: 'SIMULATIONSERVICE_DESC',
  SOURCEREFERENCEID_ASC: 'SOURCEREFERENCEID_ASC',
  SOURCEREFERENCEID_DESC: 'SOURCEREFERENCEID_DESC',
  SOURCE_ASC: 'SOURCE_ASC',
  SOURCE_DESC: 'SOURCE_DESC',
  SPECIFICATIONID_ASC: 'SPECIFICATIONID_ASC',
  SPECIFICATIONID_DESC: 'SPECIFICATIONID_DESC',
  TRACKLAYOUTID_ASC: 'TRACKLAYOUTID_ASC',
  TRACKLAYOUTID_DESC: 'TRACKLAYOUTID_DESC',
  UPDATEDAT_ASC: 'UPDATEDAT_ASC',
  UPDATEDAT_DESC: 'UPDATEDAT_DESC',
  VERSION_ASC: 'VERSION_ASC',
  VERSION_DESC: 'VERSION_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManySimResultInput = typeof SortFindManySimResultInput[keyof typeof SortFindManySimResultInput];
export const SortFindManySimulationDriveFileInput = {
  STATUS_ASC: 'STATUS_ASC',
  STATUS_DESC: 'STATUS_DESC',
  USERENUMTYPEID_ASC: 'USERENUMTYPEID_ASC',
  USERENUMTYPEID_DESC: 'USERENUMTYPEID_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManySimulationDriveFileInput = typeof SortFindManySimulationDriveFileInput[keyof typeof SortFindManySimulationDriveFileInput];
export const SortFindManySkidPlateInput = {
  BARCODEREGULATION_ASC: 'BARCODEREGULATION_ASC',
  BARCODEREGULATION_DESC: 'BARCODEREGULATION_DESC',
  INITIALTHICKNESS_ASC: 'INITIALTHICKNESS_ASC',
  INITIALTHICKNESS_DESC: 'INITIALTHICKNESS_DESC',
  NAME_ASC: 'NAME_ASC',
  NAME_DESC: 'NAME_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManySkidPlateInput = typeof SortFindManySkidPlateInput[keyof typeof SortFindManySkidPlateInput];
export const SortFindManySpecificationInput = {
  ALLOWABLEPARENTSPECIDS_ASC: 'ALLOWABLEPARENTSPECIDS_ASC',
  ALLOWABLEPARENTSPECIDS_DESC: 'ALLOWABLEPARENTSPECIDS_DESC',
  CANOPYVERSION_ASC: 'CANOPYVERSION_ASC',
  CANOPYVERSION_DESC: 'CANOPYVERSION_DESC',
  CHASSISSPECID_ASC: 'CHASSISSPECID_ASC',
  CHASSISSPECID_DESC: 'CHASSISSPECID_DESC',
  ITERATIONIDS_ASC: 'ITERATIONIDS_ASC',
  ITERATIONIDS_DESC: 'ITERATIONIDS_DESC',
  NAME_ASC: 'NAME_ASC',
  NAME_DESC: 'NAME_DESC',
  NEXTITERATIONID_ASC: 'NEXTITERATIONID_ASC',
  NEXTITERATIONID_DESC: 'NEXTITERATIONID_DESC',
  PREVITERATIONID_ASC: 'PREVITERATIONID_ASC',
  PREVITERATIONID_DESC: 'PREVITERATIONID_DESC',
  ROOTSPECIFICATIONID_ASC: 'ROOTSPECIFICATIONID_ASC',
  ROOTSPECIFICATIONID_DESC: 'ROOTSPECIFICATIONID_DESC',
  SPECIFICATIONGROUPIDS_ASC: 'SPECIFICATIONGROUPIDS_ASC',
  SPECIFICATIONGROUPIDS_DESC: 'SPECIFICATIONGROUPIDS_DESC',
  VERSION_ASC: 'VERSION_ASC',
  VERSION_DESC: 'VERSION_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManySpecificationInput = typeof SortFindManySpecificationInput[keyof typeof SortFindManySpecificationInput];
export const SortFindManySsoProviderInput = {
  NAME_ASC: 'NAME_ASC',
  NAME_DESC: 'NAME_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManySsoProviderInput = typeof SortFindManySsoProviderInput[keyof typeof SortFindManySsoProviderInput];
export const SortFindManyTagInput = {
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyTagInput = typeof SortFindManyTagInput[keyof typeof SortFindManyTagInput];
export const SortFindManyTeamInput = {
  NAME_ASC: 'NAME_ASC',
  NAME_DESC: 'NAME_DESC',
  RACESERIESID_ASC: 'RACESERIESID_ASC',
  RACESERIESID_DESC: 'RACESERIESID_DESC',
  SHORTNAME_ASC: 'SHORTNAME_ASC',
  SHORTNAME_DESC: 'SHORTNAME_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyTeamInput = typeof SortFindManyTeamInput[keyof typeof SortFindManyTeamInput];
export const SortFindManyTemplateJobListInput = {
  INDEX_ASC: 'INDEX_ASC',
  INDEX_DESC: 'INDEX_DESC',
  TITLE_ASC: 'TITLE_ASC',
  TITLE_DESC: 'TITLE_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyTemplateJobListInput = typeof SortFindManyTemplateJobListInput[keyof typeof SortFindManyTemplateJobListInput];
export const SortFindManyTemplateSessionDebriefInput = {
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyTemplateSessionDebriefInput = typeof SortFindManyTemplateSessionDebriefInput[keyof typeof SortFindManyTemplateSessionDebriefInput];
export const SortFindManyTimeSheetEntryInput = {
  PROJECTID_ASC: 'PROJECTID_ASC',
  PROJECTID_DESC: 'PROJECTID_DESC',
  TEND_ASC: 'TEND_ASC',
  TEND_DESC: 'TEND_DESC',
  TSTART_ASC: 'TSTART_ASC',
  TSTART_DESC: 'TSTART_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyTimeSheetEntryInput = typeof SortFindManyTimeSheetEntryInput[keyof typeof SortFindManyTimeSheetEntryInput];
export const SortFindManyTimingServiceConfigInput = {
  EVENTID_ASC: 'EVENTID_ASC',
  EVENTID_DESC: 'EVENTID_DESC',
  NAME_ASC: 'NAME_ASC',
  NAME_DESC: 'NAME_DESC',
  UPDATEDAT_ASC: 'UPDATEDAT_ASC',
  UPDATEDAT_DESC: 'UPDATEDAT_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyTimingServiceConfigInput = typeof SortFindManyTimingServiceConfigInput[keyof typeof SortFindManyTimingServiceConfigInput];
export const SortFindManyTrackInput = {
  ACRONYM_ASC: 'ACRONYM_ASC',
  ACRONYM_DESC: 'ACRONYM_DESC',
  NAME_ASC: 'NAME_ASC',
  NAME_DESC: 'NAME_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyTrackInput = typeof SortFindManyTrackInput[keyof typeof SortFindManyTrackInput];
export const SortFindManyTrackLayoutInput = {
  ACRONYM_ASC: 'ACRONYM_ASC',
  ACRONYM_DESC: 'ACRONYM_DESC',
  LAPLENGTHOFFICIAL_ASC: 'LAPLENGTHOFFICIAL_ASC',
  LAPLENGTHOFFICIAL_DESC: 'LAPLENGTHOFFICIAL_DESC',
  TRACKID_ASC: 'TRACKID_ASC',
  TRACKID_DESC: 'TRACKID_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyTrackLayoutInput = typeof SortFindManyTrackLayoutInput[keyof typeof SortFindManyTrackLayoutInput];
export const SortFindManyTrackableInput = {
  NAME_ASC: 'NAME_ASC',
  NAME_DESC: 'NAME_DESC',
  ROOTSPECIFICATIONID_ASC: 'ROOTSPECIFICATIONID_ASC',
  ROOTSPECIFICATIONID_DESC: 'ROOTSPECIFICATIONID_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyTrackableInput = typeof SortFindManyTrackableInput[keyof typeof SortFindManyTrackableInput];
export const SortFindManyTrackingItemInput = {
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyTrackingItemInput = typeof SortFindManyTrackingItemInput[keyof typeof SortFindManyTrackingItemInput];
export const SortFindManyTrackingMeasurementInput = {
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyTrackingMeasurementInput = typeof SortFindManyTrackingMeasurementInput[keyof typeof SortFindManyTrackingMeasurementInput];
export const SortFindManyTrackingMeasurementRecordInput = {
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyTrackingMeasurementRecordInput = typeof SortFindManyTrackingMeasurementRecordInput[keyof typeof SortFindManyTrackingMeasurementRecordInput];
export const SortFindManyTrackingRecordInput = {
  PARTID_ASC: 'PARTID_ASC',
  PARTID_DESC: 'PARTID_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyTrackingRecordInput = typeof SortFindManyTrackingRecordInput[keyof typeof SortFindManyTrackingRecordInput];
export const SortFindManyTrackingSourceAliasInput = {
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyTrackingSourceAliasInput = typeof SortFindManyTrackingSourceAliasInput[keyof typeof SortFindManyTrackingSourceAliasInput];
export const SortFindManyTrackingSourceInput = {
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyTrackingSourceInput = typeof SortFindManyTrackingSourceInput[keyof typeof SortFindManyTrackingSourceInput];
export const SortFindManyTyreInput = {
  ADDITIONALSORTPROPERTY_ASC: 'ADDITIONALSORTPROPERTY_ASC',
  ADDITIONALSORTPROPERTY_DESC: 'ADDITIONALSORTPROPERTY_DESC',
  BARCODEMANUFACTURER_ASC: 'BARCODEMANUFACTURER_ASC',
  BARCODEMANUFACTURER_DESC: 'BARCODEMANUFACTURER_DESC',
  BARCODEREGULATION_ASC: 'BARCODEREGULATION_ASC',
  BARCODEREGULATION_DESC: 'BARCODEREGULATION_DESC',
  BARCODERIM_ASC: 'BARCODERIM_ASC',
  BARCODERIM_DESC: 'BARCODERIM_DESC',
  BARCODETPMS_ASC: 'BARCODETPMS_ASC',
  BARCODETPMS_DESC: 'BARCODETPMS_DESC',
  BATTERYTPMS_ASC: 'BATTERYTPMS_ASC',
  BATTERYTPMS_DESC: 'BATTERYTPMS_DESC',
  COMPOUND_ASC: 'COMPOUND_ASC',
  COMPOUND_DESC: 'COMPOUND_DESC',
  MANUFACTURER_ASC: 'MANUFACTURER_ASC',
  MANUFACTURER_DESC: 'MANUFACTURER_DESC',
  MTYRE_ASC: 'MTYRE_ASC',
  MTYRE_DESC: 'MTYRE_DESC',
  NAME_ASC: 'NAME_ASC',
  NAME_DESC: 'NAME_DESC',
  SEASONID_ASC: 'SEASONID_ASC',
  SEASONID_DESC: 'SEASONID_DESC',
  TYPE_ASC: 'TYPE_ASC',
  TYPE_DESC: 'TYPE_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyTyreInput = typeof SortFindManyTyreInput[keyof typeof SortFindManyTyreInput];
export const SortFindManyTyreSetInput = {
  NAME_ASC: 'NAME_ASC',
  NAME_DESC: 'NAME_DESC',
  NUMBER_ASC: 'NUMBER_ASC',
  NUMBER_DESC: 'NUMBER_DESC',
  TYREIDFL_ASC: 'TYREIDFL_ASC',
  TYREIDFL_DESC: 'TYREIDFL_DESC',
  TYREIDFR_ASC: 'TYREIDFR_ASC',
  TYREIDFR_DESC: 'TYREIDFR_DESC',
  TYREIDRL_ASC: 'TYREIDRL_ASC',
  TYREIDRL_DESC: 'TYREIDRL_DESC',
  TYREIDRR_ASC: 'TYREIDRR_ASC',
  TYREIDRR_DESC: 'TYREIDRR_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyTyreSetInput = typeof SortFindManyTyreSetInput[keyof typeof SortFindManyTyreSetInput];
export const SortFindManyTyreWearInput = {
  DATE_ASC: 'DATE_ASC',
  DATE_DESC: 'DATE_DESC',
  TYREID_ASC: 'TYREID_ASC',
  TYREID_DESC: 'TYREID_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyTyreWearInput = typeof SortFindManyTyreWearInput[keyof typeof SortFindManyTyreWearInput];
export const SortFindManyUserEnumInput = {
  ACTIVE_ASC: 'ACTIVE_ASC',
  ACTIVE_DESC: 'ACTIVE_DESC',
  NAME_ASC: 'NAME_ASC',
  NAME_DESC: 'NAME_DESC',
  TYPE_ASC: 'TYPE_ASC',
  TYPE_DESC: 'TYPE_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyUserEnumInput = typeof SortFindManyUserEnumInput[keyof typeof SortFindManyUserEnumInput];
export const SortFindManyWeatherInput = {
  EVENTIDS_ASC: 'EVENTIDS_ASC',
  EVENTIDS_DESC: 'EVENTIDS_DESC',
  SOURCE_ASC: 'SOURCE_ASC',
  SOURCE_DESC: 'SOURCE_DESC',
  TIME_ASC: 'TIME_ASC',
  TIME_DESC: 'TIME_DESC',
  TYPE_ASC: 'TYPE_ASC',
  TYPE_DESC: 'TYPE_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyWeatherInput = typeof SortFindManyWeatherInput[keyof typeof SortFindManyWeatherInput];
export const SortFindManyWeatherServiceConfigInput = {
  TYPE_ASC: 'TYPE_ASC',
  TYPE_DESC: 'TYPE_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindManyWeatherServiceConfigInput = typeof SortFindManyWeatherServiceConfigInput[keyof typeof SortFindManyWeatherServiceConfigInput];
export const SortFindOneReportNoteInput = {
  EVENTID_ASC: 'EVENTID_ASC',
  EVENTID_DESC: 'EVENTID_DESC',
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC'
} as const;

export type SortFindOneReportNoteInput = typeof SortFindOneReportNoteInput[keyof typeof SortFindOneReportNoteInput];
export const TrackLabelAlignment = {
  Bottom: 'Bottom',
  BottomLeft: 'BottomLeft',
  BottomRight: 'BottomRight',
  Centered: 'Centered',
  Left: 'Left',
  Right: 'Right',
  Top: 'Top',
  TopLeft: 'TopLeft',
  TopRight: 'TopRight'
} as const;

export type TrackLabelAlignment = typeof TrackLabelAlignment[keyof typeof TrackLabelAlignment];